/**
 * Empava custom bathtub configurator - complete external application logic.
 * Unified UI v4 + Shopify Blocks for main/color/Jets/hardware/functions + PDF + optional drafts.
 * Pair with this package's custom-app.css and full section file.
 * Main product blocks supply base prices, availability and variant IDs.
 * No Liquid tags belong in this asset. SKU parsing, metafield projections and PDF generation stay here.
 * Legacy function/hardware catalogs remain only as fallback when their dedicated Blocks are absent.
 * Base sizes/prices are supplied by each section's selected Shopify products.
 */
(() => {
  'use strict';

  const TAG = 'empava-custom-bathtub';
  const COMPONENT = 'empavaCustomBathtub';
  // Repeated section includes must not register a second loader/component.
  if (customElements.get(TAG)) return;

  const CDN = {
    primary: 'https://cdn.shopify.com/s/files/1/0621/1400/5212/files/',
    docs: 'https://cdn.shopify.com/s/files/1/0682/8195/8620/files/'
  };
  function getDimensionImages(model, size){
    const filename = `${model}_${size}`;
    return {
      image:
        `${CDN.primary}${filename}.webp`,
      imageMobile:
        `${CDN.primary}${filename}_mb.webp`
    };
  
  }
  const STATIC_DATA = {
    models: [
      { id: 'Master367', title: "Master'' Wanton Swirl", isPopular: true, desc: 'Wider interior angles cater to larger physiques. Two-pillow design.', img: 'https://cdn.shopifycdn.net/s/files/1/0621/1400/5212/files/EMPV-72JT367LED.webp', sizes: [
        { id: '66X48X24', label: '66x48x24 in', price: 2511, spec: 'Master367-66.pdf', manual: 'Master367_66X48X24_manual.pdf' },
        { id: '71X48X24', label: '71x48x24 in', price: 2676, spec: 'Master367-71.pdf', manual: 'Master367_71X48X28_manual.pdf' },
        { id: '77X48X24', label: '77x48x24 in', price: 3065, spec: 'Master367-77.pdf', manual: 'Master367_77X48X28_manual.pdf' }
      ]},
      { id: 'Master351', title: "Master'' Secret Revelry", isPopular: false, desc: 'Upgraded single-person tub, enhanced thickness and a reclining slope.', img: 'https://cdn.shopifycdn.net/s/files/1/0621/1400/5212/files/EMPV-67JT351.webp', sizes: [
        { id: '59X30X25', label: '59x30x25 in', price: 2260, spec: 'Master351-59.pdf', manual: 'Master351_59X30X25_manual.pdf' },
        { id: '67X30X24', label: '67x30x24 in', price: 2365, spec: 'Master351-67.pdf', manual: 'Master351_67X30X24_manual.pdf' },
        { id: '71X33X24', label: '71x33x24 in', price: 2591, spec: 'Master351-71.pdf', manual: 'Master351_71X33X24_manual.pdf' }
      ]},
      { id: 'Master408', title: "Master'' Reflective Hue", isPopular: true, desc: 'Designed with one glass side that diffuses interior light.', img: 'https://cdn.shopifycdn.net/s/files/1/0621/1400/5212/files/EMPV-59JT408.webp', sizes: [
        { id: '59X30X24', label: '59x30x24 in', price: 2087, spec: 'Master408-59.pdf', manual: 'Master408_59X30X24_manual.pdf' },
        { id: '67X32X24', label: '67x32x24 in', price: 2191, spec: 'Master408-67.pdf', manual: 'Master408_67X32X24_manual.pdf' },
        { id: '71X33X24', label: '71x33x24 in', price: 2402, spec: 'Master408-71.pdf', manual: 'Master408_71X32X24_manual.pdf' }
      ]},
      { id: 'Master319', title: "Master'' Triangle Shell", isPopular: false, desc: 'Triangular shape offers a precise fit into any corner.', img: 'https://cdn.shopifycdn.net/s/files/1/0621/1400/5212/files/EMPAVA-JT319.webp', sizes: [
        { id: '59X59X27', label: '59x59x27 in', price: 2399, spec: 'Master319-59.pdf', manual: 'Master319_59X59X27_manual.pdf' }
      ]},
      { id: 'Master07', title: "Master'' Oval Cradle", isPopular: false, desc: 'Featuring symmetrical dual-end design pillows.', img: 'https://cdn.shopifycdn.net/s/files/1/0621/1400/5212/files/EMPV-67AIS07.webp', sizes: [
        { id: '59X30X24', label: '59x30x24 in', price: 2413, spec: 'Master07-59.pdf', manual: 'Master07_59X30X24_manual.pdf' },
        { id: '67X32X24', label: '67x32x24 in', price: 2516, spec: 'Master07-67.pdf', manual: 'Master07_67X32X24_manual.pdf' },
        { id: '71X32X24', label: '71x32x24 in', price: 2627, spec: 'Master07-71.pdf', manual: 'Master07_71X32X24_manual.pdf' }
      ]}
    ],

    // Only active Video triggers from the supplied legacy markup are enabled.
    // To enable a video later, set videoId on its function object (11-character ID).
    // Thermostat slot 4 was disabled in the source; its ID was DXT9dF-WK-I.
    functions: [
      { id: 'Detachable skirts', videoId: '', label: 'Detachable skirts', desc: 'If you want those bathtubs that are only designed for alcove, drop-in, or corner installment to fit for freestanding-type installment as well, you can customize four-skirt-type bathtubs with detachable skirts that can accommodate all types of installations.', price: 480, img: 'none', hideFor: ['Master319', 'Master07'], detailsLink: '' },
      { id: 'Handrails', videoId: '', label: 'Handrails (Add-on)', desc: 'If you live with the elderly, children, or disabled people, do think about customizing your bathtub with handrails to help stand up or get in or out of the bathtub safely.', price: 60, img: `${CDN.primary}Handrails_c.webp`, hideFor: [], detailsLink: '' },
      { id: 'PureFlow Jet Drainage System', videoId: '', label: 'PureFlow Drainage', desc: 'Experience the elegance of true cleanliness with our PureFlow™ Jet Drainage System. Designed with precision engineering, this intelligent flow path ensures every drop of water is fully released from the jet pipes after use. No stagnant water, no hidden buildup—just lasting freshness and purity.', price: 160, img: `${CDN.primary}Groundbreaking_self-clean_system.webp`, hideFor: [], isHot: true, detailsLink: '' },
      { id: 'Neck Massage Headrest', videoId: 'ffC6FQV06f8', label: 'Neck Massage Headrest', desc: 'The head is where the brain is, hence regular head massage can not only relieve stress or migraines but also improve memory and concentration. The neck massage headrest shares the same switch as the hydro massage jets.', price: 120, img: `${CDN.primary}Neck_Massage_Headrest.webp`, hideFor: ['Master319', 'Master07'], detailsLink: 'https://empava.com/blogs/new/all-about-custom-tub-functions#Bathtub_Pillow_Function' },
      { id: 'Oxygen Revi-skin Therapy', videoId: 'lStJTNfvLlg', label: 'Oxygen Revi-skin', desc: 'The oxygen revi-skin therapy produces microbubbles with a diameter of 10-40 micrometers. They can penetrate deep into your pores, unlike ordinary water and soap, effectively cleaning the skin without causing irritation.', price: 1006, img: `${CDN.primary}Oxygen_Revi-skin_Therapy.webp`, hideFor: ['Master07'], isHot: true, detailsLink: 'https://empava.com/blogs/new/all-about-custom-tub-functions#Revi-skin_Oxygen_Therapy' },
      { id: 'Pre-installed Thermostat', videoId: '', label: 'Thermostat', desc: 'The pre-installed thermostat helps maintain water temperature (96.8 To 107.6-degree Fahrenheit) to extend your experience.', price: 316, img: `${CDN.primary}Pre-installed_Thermostat.webp`, hideFor: [], detailsLink: 'https://empava.com/blogs/new/all-about-custom-tub-functions#Bathtub_Thermostat_Function', hasBundle: true, bundleId: 'Waterfall with colorful lights bundle', bundlePrice: 160, bundleOrigPrice: 230, bundleImg: `${CDN.primary}Tubcart.webp` },
      { id: 'Aromatherapy', videoId: 'JKcn8V-N2Ro', label: 'Aromatherapy', desc: 'Aromatherapy infuses the air with scent as the hot water bubbles through the jets.', price: 80, img: `${CDN.primary}Aromatherapy.webp`, hideFor: [], detailsLink: 'https://empava.com/blogs/new/all-about-custom-tub-functions#Aromatherapy_Bath_Function' },
      { id: 'Waterfall with colorful lights', videoId: 'Z3zG6ErD-QM', label: 'Waterfall + Lights', desc: 'If chromatherapy alone is not enough, then get its upgraded version with a waterfall feature that provides a double soothing mood.', price: 230, img: `${CDN.primary}Waterfall_with_colorful_lights.webp`, hideFor: ['Master319'], detailsLink: 'https://empava.com/blogs/new/all-about-custom-tub-functions#Waterfall_Function' },
      { id: 'Chromotherapy', videoId: 'P-g-Jx51qJY', label: 'Chromotherapy', desc: 'Infuses your bath water with a range of healing hues, spanning from warm (stimulating) to cool (calming).', price: 160, img: `${CDN.primary}Chromotherapy.webp`, hideFor: [], detailsLink: 'https://empava.com/blogs/new/all-about-custom-tub-functions#Chromotherapy_Function' },
      { id: 'Exterior LED lights', videoId: '', label: 'Exterior LED lights', desc: 'Tired of mediocre chromatherapy LED lights? Then try this type of in-and-out chromatherapy lights which can not only bring unparalleled efficacy but also create an ambiance of utmost romance!', price: 170, img: `${CDN.primary}LED.webp`, hideFor: [], detailsLink: '' }
    ],

    hardwareCats: [
      { category: 'Faucet color', showFor: 'all', options: [
        { id: 'Chrome', label: 'Chrome', price: 0 }, { id: 'Brushed Nickel', label: 'Brushed Nickel', price: 160 },
        { id: 'Brushed Gold', label: 'Brushed Gold', price: 175, isHot: true }, { id: 'Bronze', label: 'Bronze', price: 185 },
        { id: 'Glossy Black', label: 'Glossy Black', price: 140, isHot: true }
      ]},
      { category: 'Headrest color', showFor: 'all', options: [{ id: 'White', label: 'White', price: 15 }, { id: 'Black', label: 'Black', price: 0 }] },
      { category: 'Drain Cap Finish', showFor: 'all', options: [
        { id: 'Chrome', label: 'Chrome', price: 0 }, { id: 'Brushed Nickel', label: 'Brushed Nickel', price: 50 },
        { id: 'Brushed Gold', label: 'Brushed Gold', price: 50, isHot: true }, { id: 'Bronze', label: 'Bronze', price: 50 },
        { id: 'Glossy Black', label: 'Glossy Black', price: 50, isHot: true }
      ]},
      { category: 'Nozzle Color', showFor: 'all', dependsOnJet: true, options: [
        { id: 'Chrome', label: 'Chrome', price: 0 }, { id: 'Brushed Nickel', label: 'Brushed Nickel', price: 280 },
        { id: 'Brushed Gold', label: 'Brushed Gold', price: 280 }, { id: 'Bronze', label: 'Bronze', price: 280 },
        { id: 'Glossy Black', label: 'Glossy Black', price: 280 }
      ]},
      { category: 'Drain Location', showFor: 'all', options: [
        { id: 'left', label: 'Left', price: 0, showForModels: ['Master351', 'Master367', 'Master319'] },
        { id: 'center', label: 'Center', price: 0, showForModels: ['Master07', 'Master351', 'Master367', 'Master408'] },
        { id: 'right', label: 'Right', price: 0, showForModels: ['Master351', 'Master367'] }
      ]},
      { category: 'Pillow position', showFor: 'all', options: [
        { id: 'Default', label: 'Default', price: 0, showForModels: ['Master319', 'Master07'] },
        { id: 'Centered', label: 'Centered', price: 0, showForModels: ['Master367'] },
        { id: 'Left Side', label: 'Left Side', price: 0, showForModels: ['Master367', 'Master351', 'Master408'] },
        { id: 'Right Side', label: 'Right Side', price: 0, showForModels: ['Master367', 'Master351', 'Master408'] },
        { id: 'Diagonal-Right Top & Left Bottom', label: 'Diagonal RT & LB', price: 0, showForModels: ['Master367'] },
        { id: 'Diagonal-Left Top & Right Bottom', label: 'Diagonal LT & RB', price: 0, showForModels: ['Master367'] }
      ]},
      { category: 'Handrails', showFor: ['Master408'], options: [
        { id: 'Brushed Gold', label: 'Brushed Gold', price: 50 }, { id: 'Brushed Nickel', label: 'Brushed Nickel', price: 50 },
        { id: 'Glossy Black', label: 'Glossy Black', price: 50 }, { id: 'Bronze', label: 'Bronze', price: 50 }
      ]}
    ]
  };

  const IMAGE_MAPS = {
    headrest: {
      Master367_White: '1_22d47fde-e12a-4659-9e93-42fec5cbd6c3.webp', Master367_Black: '2_ea09260a-2687-4dcd-b909-8d4b930d1857.webp',
      Master351_White: '6.webp', Master351_Black: '7.webp', Master408_White: '2_20d9a18e-ef85-4b5a-95be-7dd59509727c.webp',
      Master408_Black: '1_3d04bec6-603a-4a1c-8265-b1b4217689b3.webp', Master319_White: '5.webp', Master319_Black: '1.webp',
      Master07_White: '3.webp', Master07_Black: '2.webp'
    },
    drain: {
      Master07_center: 'mid_a215d34d-658c-4e83-af62-84845c886e5e.webp', Master351_left: 'left.webp',
      Master351_center: 'mid_17e44748-d116-4191-8f4a-deba630d8f1c.webp', Master351_right: 'right.webp',
      Master367_left: 'left_998b11c4-d966-4293-83d2-1cd58cdcbc72.webp', Master367_center: 'mid_197bfdae-5574-4628-ad1e-624e50e87bc4.webp',
      Master367_right: 'right_a4b094d0-a924-4a63-9796-db67cb98e8db.webp', Master408_center: 'mid_a49cbcc7-2f88-4a7d-adaf-b2506a1dd1c7.webp',
      Master319_left: 'mid.webp'
    },
    pillow: {
      Master319_Default: 'EMPV-Master319_i.png', Master07_Default: 'EMPV-Master07_i.png', Master367_Centered: 'Master367-Centered.png',
      'Master367_Left Side': 'Master367-Left_Side.png', 'Master367_Right Side': 'Master367-Right_Side.png',
      'Master367_Diagonal-Right Top & Left Bottom': 'Master367-Diagonal_RT_LB.png',
      'Master367_Diagonal-Left Top & Right Bottom': 'Master367-Diagonal_LT_RB.png',
      'Master351_Left Side': 'Master351-Left_Side.png', 'Master351_Right Side': 'Master351-Right_Side.png',
      'Master408_Left Side': 'Master408-Left_Side.png', 'Master408_Right Side': 'Master408-Right_Side.png'
    }
  };

  const CART_SKU_PREFIX = {
    'Faucet color': 'F_',
    'Headrest color': 'Headrest_',
    'Drain Cap Finish': 'D_',
    'Nozzle Color': 'NC_',
    'Drain Location': 'sku_',
    'Handrails': 'Handrails_'
  };

  const THERMOSTAT = 'Pre-installed Thermostat';
  const ALPINE_URL = 'https://cdn.jsdelivr.net/npm/alpinejs@3.14.9/dist/cdn.min.js';
  const money = new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', minimumFractionDigits: 2
  });
  const clone = value => JSON.parse(JSON.stringify(value));
  const amount = value => Number.isFinite(Number(value)) ? Number(value) : 0;
  const registered = new WeakSet();
  const headerLocks = new WeakMap();
  let alpinePromise;

  // Layout integration only. No catalog, pricing or cart behavior is changed.
  const pageOwners = new Set();
  let pageClassWasPresent = false;
  const PAGE_CLASS = 'empava-custom-app-page';

  function setPageLayoutLock(owner, active) {
    const html = document.documentElement;
    if (active) {
      if (!pageOwners.size) pageClassWasPresent = html.classList.contains(PAGE_CLASS);
      pageOwners.add(owner);
      html.classList.add(PAGE_CLASS);
    } else {
      pageOwners.delete(owner);
      if (!pageOwners.size && !pageClassWasPresent) html.classList.remove(PAGE_CLASS);
    }
  }

  function allowedFor(rule, sku) {
    if (!rule || rule === 'all') return true;
    const values = Array.isArray(rule) ? rule : String(rule).split(/[,\n]/);
    return values.some(value => String(value).trim() === sku);
  }

  function normalizeOption(option) {
    return {
      ...option,
      id: String(option.id ?? option.variantId ?? ''),
      label: String(option.label || option.title || option.id || ''),
      price: amount(option.price)
    };
  }

  // Save/restore the actual prior display value and share ownership across apps.
  function setHeaderLock(header, owner, hide) {
    if (!header) return;
    let lock = headerLocks.get(header);
    if (hide) {
      if (!lock) {
        lock = {
          owners: new Set(),
          display: header.style.getPropertyValue('display'),
          priority: header.style.getPropertyPriority('display')
        };
        headerLocks.set(header, lock);
      }
      lock.owners.add(owner);
      header.style.setProperty('display', 'none');
    } else if (lock) {
      lock.owners.delete(owner);
      if (!lock.owners.size) {
        if (lock.display) header.style.setProperty('display', lock.display, lock.priority);
        else header.style.removeProperty('display');
        headerLocks.delete(header);
      }
    }
  }


  // Feature videos: one active iframe, loaded only after an explicit click.
  // No jQuery, YT.Player, global YouTube callback or cross-origin DOM access.
  // Closing destroys the iframe; reopening starts the video from the beginning.
  const FEATURE_VIDEO_OPTIONS = Object.freeze({ autoplay: true, muted: true });
  const isVideoId = value => typeof value === 'string' && /^[A-Za-z0-9_-]{11}$/.test(value);
  let activeFeatureVideo = null;

  function createFeatureVideoController(root) {
    const dialog = root.querySelector('[data-ea-video-dialog]');
    if (!dialog) return null;
    const mount = dialog.querySelector('[data-ea-video-mount]');
    const title = dialog.querySelector('[data-ea-video-title]');
    const status = dialog.querySelector('[data-ea-video-status]');
    const external = dialog.querySelector('[data-ea-video-external]');
    const closeButton = dialog.querySelector('[data-ea-video-close]');
    const reloadButton = dialog.querySelector('[data-ea-video-reload]');
    let frame = null;
    let feature = null;
    let opener = null;
    let timer;
    let pressedBackdrop = false;
    let disposed = false;
    const listeners = [];
    const listen = (target, event, handler) => {
      target.addEventListener(event, handler);
      listeners.push(() => target.removeEventListener(event, handler));
    };
    const setStatus = (state, text) => {
      dialog.dataset.playerState = state;
      status.textContent = text;
    };
    const stop = () => {
      clearTimeout(timer);
      if (frame) frame.onload = frame.onerror = null;
      mount.replaceChildren();
      frame = null;
    };
    const load = () => {
      stop();
      if (!feature || disposed || !dialog.open) return;
      const next = document.createElement('iframe');
      const params = new URLSearchParams({
        autoplay: FEATURE_VIDEO_OPTIONS.autoplay ? '1' : '0',
        mute: FEATURE_VIDEO_OPTIONS.muted ? '1' : '0',
        playsinline: '1', controls: '1', rel: '0'
      });
      next.title = `${feature.label} - YouTube video`;
      next.className = 'ea-video-frame';
      next.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      next.allowFullscreen = true;
      // YouTube needs a Referer; do not set no-referrer or sandbox the embed.
      next.referrerPolicy = 'strict-origin-when-cross-origin';
      setStatus('loading', 'Loading player...');
      next.onload = () => {
        if (frame !== next || disposed) return;
        clearTimeout(timer);
        // iframe load is NOT a playback-success event. Never claim it is.
        setStatus('loaded', 'Use the player controls for sound and full screen.');
      };
      next.onerror = () => {
        if (frame !== next || disposed) return;
        clearTimeout(timer);
        setStatus('waiting', 'Player unavailable? Try Reload or open on YouTube.');
      };
      timer = setTimeout(() => {
        if (frame === next && !disposed) {
          setStatus('waiting', 'Taking longer than expected? Try Reload or open on YouTube.');
        }
      }, 12000);
      frame = next;
      next.src = `https://www.youtube.com/embed/${feature.videoId}?${params}`;
      mount.appendChild(next);
    };
    const close = ({ restoreFocus = true } = {}) => {
      if (!feature && !dialog.open && !frame) return;
      const target = opener;
      opener = null;
      feature = null;
      pressedBackdrop = false;
      stop();
      if (dialog.open && typeof dialog.close === 'function') dialog.close();
      if (activeFeatureVideo === api) activeFeatureVideo = null;
      if (restoreFocus && target?.isConnected && !disposed) {
        target.focus({ preventScroll: true });
      }
    };
    const open = (item, trigger) => {
      if (disposed || !isVideoId(item?.videoId)) return false;
      const watchUrl = `https://www.youtube.com/watch?v=${item.videoId}`;
      // Older embedded browsers still get a working video link, not a broken modal.
      if (typeof dialog.showModal !== 'function') {
        window.open(watchUrl, '_blank', 'noopener');
        return false;
      }
      if (activeFeatureVideo && activeFeatureVideo !== api) {
        activeFeatureVideo.close({ restoreFocus: false });
      }
      if (dialog.open && feature?.videoId === item.videoId) {
        closeButton.focus({ preventScroll: true });
        return true;
      }
      feature = { videoId: item.videoId, label: item.label || item.id };
      opener = trigger?.focus ? trigger : document.activeElement;
      title.textContent = feature.label;
      external.href = watchUrl;
      try {
        if (!dialog.open) dialog.showModal();
      } catch (error) {
        close({ restoreFocus: false });
        window.open(watchUrl, '_blank', 'noopener');
        return false;
      }
      activeFeatureVideo = api;
      load();
      closeButton.focus({ preventScroll: true });
      return true;
    };
    const outside = event => {
      const box = dialog.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right
        || event.clientY < box.top || event.clientY > box.bottom;
    };
    const api = {
      open, close,
      destroy() {
        if (disposed) return;
        close({ restoreFocus: false });
        disposed = true;
        listeners.forEach(remove => remove());
      }
    };
    listen(closeButton, 'click', () => close());
    listen(reloadButton, 'click', () => load());
    listen(external, 'click', () => close({ restoreFocus: false }));
    listen(dialog, 'cancel', event => { event.preventDefault(); close(); });
    // Native close can also be triggered outside this controller.
    // Ignore a delayed close event if the dialog has already reopened.
    listen(dialog, 'close', () => { if (!dialog.open) close(); });
    listen(dialog, 'pointerdown', event => { pressedBackdrop = event.target === dialog && outside(event); });
    listen(dialog, 'pointercancel', () => { pressedBackdrop = false; });
    listen(dialog, 'click', event => {
      if (pressedBackdrop && event.target === dialog && outside(event)) close();
      pressedBackdrop = false;
    });
    listen(window, 'pagehide', () => close({ restoreFocus: false }));
    return api;
  }


  // Shared native-dialog lifecycle for summary, feedback and 360 preview.
  // There is no document-wide click handler and no global modal state.
  function createDialogController(root, onChange) {
    const panels = new Map([...root.querySelectorAll('[data-ec-dialog]')]
      .map(element => [element.dataset.ecDialog, element]));
    const shell = root.querySelector('[data-ec-shell]');
    const listeners = [];
    let current = null;
    let opener = null;
    let backdropDown = false;
    let disposed = false;
    let shellWasInert = false;
    const listen = (element, name, fn) => {
      element.addEventListener(name, fn);
      listeners.push(() => element.removeEventListener(name, fn));
    };
    const outside = (element, event) => {
      const box = element.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right
        || event.clientY < box.top || event.clientY > box.bottom;
    };
    const close = (name = current, { restoreFocus = true } = {}) => {
      const element = panels.get(name);
      if (!element) return;
      const target = current === name ? opener : null;
      if (current === name) { current = null; opener = null; }
      if (element.dataset.fallback === 'true') {
        element.removeAttribute('open');
        delete element.dataset.fallback;
        if (shell) shell.inert = shellWasInert;
      } else if (element.open) element.close();
      backdropDown = false;
      onChange(name, false);
      if (restoreFocus && target?.isConnected && !disposed) target.focus({ preventScroll: true });
    };
    const closeAll = (options = {}) => {
      if (current) close(current, options);
    };
    const open = (name, trigger) => {
      const element = panels.get(name);
      if (!element || disposed) return false;
      if (current === name && element.open) return true;
      closeAll({ restoreFocus: false });
      current = name;
      opener = trigger?.focus ? trigger : document.activeElement;
      onChange(name, true);
      if (typeof element.showModal === 'function') {
        try { element.showModal(); }
        catch (error) { close(name); console.error('[EmpavaDialog]', error); return false; }
      } else {
        // Basic in-app fallback for older embedded browsers. Current browsers use top layer.
        shellWasInert = shell?.inert || false;
        if (shell) shell.inert = true;
        element.dataset.fallback = 'true';
        element.setAttribute('open', '');
      }
      (element.querySelector('[data-ec-initial-focus]') || element.querySelector('button'))
        ?.focus({ preventScroll: true });
      return true;
    };
    panels.forEach((element, name) => {
      listen(element, 'cancel', event => { event.preventDefault(); close(name); });
      listen(element, 'close', () => { if (!element.open && current === name) close(name); });
      listen(element, 'pointerdown', event => { backdropDown = event.target === element && outside(element, event); });
      listen(element, 'pointercancel', () => { backdropDown = false; });
      listen(element, 'click', event => {
        if (backdropDown && event.target === element && outside(element, event)) close(name);
        backdropDown = false;
      });
      listen(element, 'keydown', event => {
        if (element.dataset.fallback !== 'true') return;
        if (event.key === 'Escape') { event.preventDefault(); close(name); }
        if (event.key !== 'Tab') return;
        const controls = [...element.querySelectorAll('button:not(:disabled), a[href], input:not(:disabled), textarea:not(:disabled), [tabindex="0"]')]
          .filter(control => control.getClientRects().length);
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      });
    });
    listen(window, 'pagehide', () => closeAll({ restoreFocus: false }));
    return { open, close, closeAll, destroy() {
      closeAll({ restoreFocus: false }); disposed = true; listeners.forEach(remove => remove());
    } };
  }

  // Original feedback wording and POST field names, including questions 6-8.
  // The original wording says 1-10, but its range input was 0-10. Kept unchanged.
  const FEEDBACK_QUESTIONS = [
    { number: 4, key: 'options', name: 'What other customization options would you like us to offer', label: 'What other customization options would you like us to offer?' },
    { number: 5, key: 'information', name: 'What other information would you like to see on this page', label: 'What other information would you like to see on this page?' },
    { number: 6, key: 'improvements', name: 'Is there anything you think we can improve', label: 'Is there anything you think we can improve?' },
    { number: 7, key: 'decision', name: 'What has the greatest influence on your purchasing decision', label: 'What has the greatest influence on your purchasing decision?' },
    { number: 8, key: 'experience', name: 'Tell us about your overall experience with the website', label: 'Tell us about your overall experience with the website?' }
  ];
  const CONFIG_SECTIONS = [
    { id: 'size', number: '01', label: 'Size' },
    { id: 'color', number: '02', label: 'Color' },
    { id: 'massage', number: '03', label: 'Massage' },
    { id: 'hardware', number: '04', label: 'Hardware' },
    { id: 'functions', number: '05', label: 'Functions' }
  ];

  // Small, self-contained PDF 1.4 writer. No remote library, HTML-to-canvas
  // screenshot, external font file, global namespace or server upload is needed.
  // Latin text uses standard PDF fonts; other scripts are rendered per line with
  // the browser's fonts and retain their original text in /ActualText metadata.
  const PDF_WINANSI = new Map([[8364,128],[8218,130],[402,131],[8222,132],[8230,133],[8224,134],[8225,135],[710,136],[8240,137],[352,138],[8249,139],[338,140],[381,142],[8216,145],[8217,146],[8220,147],[8221,148],[8226,149],[8211,150],[8212,151],[732,152],[8482,153],[353,154],[8250,155],[339,156],[382,158],[376,159]]);
  const pdfBytes = text => new TextEncoder().encode(text);
  const pdfNumber = value => Number(value).toFixed(3).replace(/\.?0+$/, '') || '0';
  const pdfClean = value => String(value ?? '').replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, '').replace(/\r\n?/g, '\n').replace(/\t/g, ' ');
  const pdfCode = char => {
    const code = char.codePointAt(0);
    return (code >= 32 && code <= 126) || (code >= 160 && code <= 255) ? code : PDF_WINANSI.get(code);
  };
  const pdfLiteral = text => '(' + [...pdfClean(text)].map(char => {
    const code = pdfCode(char);
    if (code === undefined) throw new Error('Unsupported standard-font character.');
    return code >= 32 && code < 127 && !/[()\\]/.test(char)
      ? char : '\\' + code.toString(8).padStart(3, '0');
  }).join('') + ')';
  const pdfUtf16 = text => '<FEFF' + pdfClean(text).split('').map(char => char.charCodeAt(0).toString(16).padStart(4, '0')).join('') + '>';
  const fromDataURL = url => Uint8Array.from(atob(url.slice(url.indexOf(',') + 1)), char => char.charCodeAt(0));
  const pdfSafeURL = value => {
    try { const url = new URL(value); return /^https?:$/.test(url.protocol) ? url.href : ''; }
    catch { return ''; }
  };
  const pdfRGB = value => {
    const context = document.createElement('canvas').getContext('2d');
    if (!context) return [0.19, 0.36, 0.27];
    context.fillStyle = '#315c44'; context.fillStyle = value || '#315c44';
    context.fillRect(0, 0, 1, 1);
    const rgba = context.getImageData(0, 0, 1, 1).data;
    return [...rgba].slice(0, 3).map(channel => channel / 255);
  };
  // Standard Helvetica metrics in 1/1000-em units; these are numeric metrics,
  // not downloadable or embedded font programs.
  const PDF_WIDTHS = [{"32":278,"33":278,"34":355,"35":556,"36":556,"37":889,"38":667,"39":191,"40":333,"41":333,"42":389,"43":584,"44":278,"45":333,"46":278,"47":278,"48":556,"49":556,"50":556,"51":556,"52":556,"53":556,"54":556,"55":556,"56":556,"57":556,"58":278,"59":278,"60":584,"61":584,"62":584,"63":556,"64":1015,"65":667,"66":667,"67":722,"68":722,"69":667,"70":611,"71":778,"72":722,"73":278,"74":500,"75":667,"76":556,"77":833,"78":722,"79":778,"80":667,"81":778,"82":722,"83":667,"84":611,"85":722,"86":667,"87":944,"88":667,"89":667,"90":611,"91":278,"92":278,"93":278,"94":469,"95":556,"96":333,"97":556,"98":556,"99":500,"100":556,"101":556,"102":278,"103":556,"104":556,"105":222,"106":222,"107":500,"108":222,"109":833,"110":556,"111":556,"112":556,"113":556,"114":333,"115":500,"116":278,"117":556,"118":500,"119":722,"120":500,"121":500,"122":500,"123":334,"124":260,"125":334,"126":584,"127":761,"128":556,"130":222,"131":556,"132":333,"133":1000,"134":556,"135":556,"136":333,"137":1000,"138":667,"139":333,"140":1000,"142":611,"145":222,"146":222,"147":333,"148":333,"149":350,"150":556,"151":1000,"152":333,"153":1000,"154":500,"155":333,"156":944,"158":500,"159":667,"160":278,"161":333,"162":556,"163":556,"164":556,"165":556,"166":260,"167":556,"168":333,"169":737,"170":370,"171":556,"172":584,"173":333,"174":737,"175":333,"176":400,"177":584,"178":333,"179":333,"180":333,"181":556,"182":537,"183":278,"184":333,"185":333,"186":365,"187":556,"188":834,"189":834,"190":834,"191":611,"192":667,"193":667,"194":667,"195":667,"196":667,"197":667,"198":1000,"199":722,"200":667,"201":667,"202":667,"203":667,"204":278,"205":278,"206":278,"207":278,"208":722,"209":722,"210":778,"211":778,"212":778,"213":778,"214":778,"215":584,"216":778,"217":722,"218":722,"219":722,"220":722,"221":667,"222":667,"223":611,"224":556,"225":556,"226":556,"227":556,"228":556,"229":556,"230":889,"231":500,"232":556,"233":556,"234":556,"235":556,"236":278,"237":278,"238":278,"239":278,"240":556,"241":556,"242":556,"243":556,"244":556,"245":556,"246":556,"247":584,"248":611,"249":556,"250":556,"251":556,"252":556,"253":500,"254":556,"255":500},{"32":278,"33":333,"34":474,"35":556,"36":556,"37":889,"38":722,"39":238,"40":333,"41":333,"42":389,"43":584,"44":278,"45":333,"46":278,"47":278,"48":556,"49":556,"50":556,"51":556,"52":556,"53":556,"54":556,"55":556,"56":556,"57":556,"58":333,"59":333,"60":584,"61":584,"62":584,"63":611,"64":975,"65":722,"66":722,"67":722,"68":722,"69":667,"70":611,"71":778,"72":722,"73":278,"74":556,"75":722,"76":611,"77":833,"78":722,"79":778,"80":667,"81":778,"82":722,"83":667,"84":611,"85":722,"86":667,"87":944,"88":667,"89":667,"90":611,"91":333,"92":278,"93":333,"94":584,"95":556,"96":333,"97":556,"98":611,"99":556,"100":611,"101":556,"102":333,"103":611,"104":611,"105":278,"106":278,"107":556,"108":278,"109":889,"110":611,"111":611,"112":611,"113":611,"114":389,"115":556,"116":333,"117":611,"118":556,"119":778,"120":556,"121":556,"122":500,"123":389,"124":280,"125":389,"126":584,"127":761,"128":556,"130":278,"131":556,"132":500,"133":1000,"134":556,"135":556,"136":333,"137":1000,"138":667,"139":333,"140":1000,"142":611,"145":278,"146":278,"147":500,"148":500,"149":350,"150":556,"151":1000,"152":333,"153":1000,"154":556,"155":333,"156":944,"158":500,"159":667,"160":278,"161":333,"162":556,"163":556,"164":556,"165":556,"166":280,"167":556,"168":333,"169":737,"170":370,"171":556,"172":584,"173":333,"174":737,"175":333,"176":400,"177":584,"178":333,"179":333,"180":333,"181":611,"182":556,"183":278,"184":333,"185":333,"186":365,"187":556,"188":834,"189":834,"190":834,"191":611,"192":722,"193":722,"194":722,"195":722,"196":722,"197":722,"198":1000,"199":722,"200":667,"201":667,"202":667,"203":667,"204":278,"205":278,"206":278,"207":278,"208":722,"209":722,"210":778,"211":778,"212":778,"213":778,"214":778,"215":584,"216":778,"217":722,"218":722,"219":722,"220":722,"221":667,"222":667,"223":611,"224":556,"225":556,"226":556,"227":556,"228":556,"229":556,"230":889,"231":556,"232":556,"233":556,"234":556,"235":556,"236":278,"237":278,"238":278,"239":278,"240":611,"241":611,"242":611,"243":611,"244":611,"245":611,"246":611,"247":584,"248":611,"249":611,"250":611,"251":611,"252":611,"253":556,"254":611,"255":556}];

  class ConfigurationPDF {
    constructor(title) {
      this.objects = [null, null, null];
      this.fonts = [this.object('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>'),
        this.object('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>')];
      this.pages = []; this.images = [];
      this.info = this.object(`<< /Title ${pdfUtf16(title)} /Author (EMPAVA) /Creator (Empava Custom Studio) /Subject (Customer configuration estimate) >>`);
      this.canvas = document.createElement('canvas');
      this.context = this.canvas.getContext('2d');
    }
    object(value) { this.objects.push(typeof value === 'string' ? pdfBytes(value) : value); return this.objects.length - 1; }
    stream(dictionary, data) {
      return this.object(new Blob([pdfBytes(`<< ${dictionary} /Length ${data.byteLength} >>\nstream\n`), data, pdfBytes('\nendstream')]));
    }
    page() {
      this.current = { commands: [], links: [], id: this.object('') };
      this.pages.push(this.current); return this.current;
    }
    command(value) { this.current.commands.push(value); }
    width(text, size, bold = false) {
      const chars = [...pdfClean(text)];
      if (chars.every(char => pdfCode(char) !== undefined)) {
        return chars.reduce((sum, char) => sum + (PDF_WIDTHS[bold ? 1 : 0][pdfCode(char)] || 600), 0) * size / 1000;
      }
      if (!this.context) throw new Error('Text rendering is unavailable in this browser.');
      this.context.font = `${bold ? 'bold' : 'normal'} ${size}px Arial, sans-serif`;
      return this.context.measureText(text).width;
    }
    wrap(text, width, size = 11, bold = false) {
      const lines = [];
      for (const paragraph of pdfClean(text).split('\n')) {
        let line = '';
        for (const word of paragraph.split(/\s+/).filter(Boolean)) {
          const candidate = line ? `${line} ${word}` : word;
          if (this.width(candidate, size, bold) <= width) { line = candidate; continue; }
          if (line) { lines.push(line); line = ''; }
          if (this.width(word, size, bold) <= width) { line = word; continue; }
          for (const char of word) {
            if (line && this.width(line + char, size, bold) > width) { lines.push(line); line = ''; }
            line += char;
          }
        }
        lines.push(line);
      }
      return lines;
    }
    text(text, x, top, size = 11, color = [0.145,0.2,0.17], bold = false, align = 'left') {
      const value = pdfClean(text); if (!value) return;
      const width = this.width(value, size, bold);
      if (align === 'right') x -= width;
      if (align === 'center') x -= width / 2;
      if ([...value].every(char => pdfCode(char) !== undefined)) {
        this.command(`BT /F${bold ? 2 : 1} ${pdfNumber(size)} Tf ${color.map(pdfNumber).join(' ')} rg 1 0 0 1 ${pdfNumber(x)} ${pdfNumber(842 - top - size)} Tm ${pdfLiteral(value)} Tj ET`);
      } else {
        // Keep non-Latin merchant-entered labels visible without silently dropping
        // glyphs. Only this line is rasterized; the rest of the PDF remains text.
        const scale = 3;
        this.canvas.width = Math.max(1, Math.ceil((width + 4) * scale));
        this.canvas.height = Math.ceil(size * 1.8 * scale);
        const ctx = this.canvas.getContext('2d');
        ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
        ctx.scale(scale, scale); ctx.font = `${bold ? 'bold' : 'normal'} ${size}px Arial, sans-serif`;
        ctx.textBaseline = 'alphabetic'; ctx.fillStyle = `rgb(${color.map(c => Math.round(c * 255)).join(',')})`;
        ctx.fillText(value, 0, size);
        const img = this.image(fromDataURL(this.canvas.toDataURL('image/jpeg', .97)), this.canvas.width, this.canvas.height);
        this.command(`/Span << /ActualText ${pdfUtf16(value)} >> BDC`);
        this.drawImage(img, x, top, this.canvas.width / scale, this.canvas.height / scale);
        this.command('EMC');
      }
    }
    rect(x, top, width, height, color) {
      this.command(`q ${color.map(pdfNumber).join(' ')} rg ${pdfNumber(x)} ${pdfNumber(842 - top - height)} ${pdfNumber(width)} ${pdfNumber(height)} re f Q`);
    }
    line(x1, top, x2, color = [.85,.88,.85], weight = .6) {
      this.command(`q ${color.map(pdfNumber).join(' ')} RG ${pdfNumber(weight)} w ${pdfNumber(x1)} ${pdfNumber(842 - top)} m ${pdfNumber(x2)} ${pdfNumber(842 - top)} l S Q`);
    }
    image(bytes, width, height) {
      const id = this.stream(`/Type /XObject /Subtype /Image /Width ${width} /Height ${height} /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode`, bytes);
      const image = { id, name: 'Im' + (this.images.length + 1), width, height };
      this.images.push(image); return image;
    }
    drawImage(image, x, top, width, height) {
      this.command(`q ${pdfNumber(width)} 0 0 ${pdfNumber(height)} ${pdfNumber(x)} ${pdfNumber(842 - top - height)} cm /${image.name} Do Q`);
    }
    link(label, value, x, top, color) {
      const url = pdfSafeURL(value); if (!url) return;
      this.text(label, x, top, 10, color, true);
      const width = this.width(label, 10, true);
      this.line(x, top + 14, x + width, color, .45);
      this.current.links.push(this.object(`<< /Type /Annot /Subtype /Link /Rect [${x} ${842-top-16} ${x+width} ${842-top+2}] /Border [0 0 0] /A << /S /URI /URI ${pdfLiteral(url)} >> >>`));
    }
    async blob() {
      const imageResources = this.images.map(img => `/${img.name} ${img.id} 0 R`).join(' ');
      for (const page of this.pages) {
        const content = this.stream('', pdfBytes(page.commands.join('\n')));
        this.objects[page.id] = pdfBytes(`<< /Type /Page /Parent 2 0 R /MediaBox [0 0 595 842] /Resources << /Font << /F1 ${this.fonts[0]} 0 R /F2 ${this.fonts[1]} 0 R >> /XObject << ${imageResources} >> >> /Contents ${content} 0 R /Annots [${page.links.map(id=>`${id} 0 R`).join(' ')}] >>`);
      }
      this.objects[1] = pdfBytes('<< /Type /Catalog /Pages 2 0 R /Lang (en-US) /ViewerPreferences << /DisplayDocTitle true >> >>');
      this.objects[2] = pdfBytes(`<< /Type /Pages /Count ${this.pages.length} /Kids [${this.pages.map(page => `${page.id} 0 R`).join(' ')}] >>`);
      const parts = [pdfBytes('%PDF-1.4\n%Empava configuration\n')];
      const offsets = [0]; let offset = parts[0].byteLength;
      for (let id = 1; id < this.objects.length; id++) {
        offsets[id] = offset;
        const object = new Blob([`${id} 0 obj\n`, this.objects[id], '\nendobj\n']);
        parts.push(object); offset += object.size;
      }
      parts.push(pdfBytes(`xref\n0 ${this.objects.length}\n0000000000 65535 f \n` + offsets.slice(1).map(pos => `${String(pos).padStart(10, '0')} 00000 n \n`).join('') +
        `trailer\n<< /Size ${this.objects.length} /Root 1 0 R /Info ${this.info} 0 R >>\nstartxref\n${offset}\n%%EOF\n`));
      return new Blob(parts, { type: 'application/pdf' });
    }
  }

  async function configurationPhoto(url, signal) {
    if (!pdfSafeURL(url) || signal?.aborted) return null;
    return new Promise(resolve => {
      const image = new Image(); let done = false;
      const finish = result => {
        if (done) return; done = true; clearTimeout(timer);
        image.onload = image.onerror = null;
        signal?.removeEventListener('abort', abort); resolve(result);
      };
      const abort = () => { finish(null); image.src = ''; };
      const timer = setTimeout(abort, 8000);
      signal?.addEventListener('abort', abort, { once: true });
      image.crossOrigin = 'anonymous'; image.decoding = 'async';
      image.onerror = () => finish(null);
      image.onload = () => {
        try {
          if (!image.naturalWidth || !image.naturalHeight) return finish(null);
          const scale = Math.min(1, 1400 / Math.max(image.naturalWidth, image.naturalHeight));
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
          canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
          const context = canvas.getContext('2d');
          if (!context) return finish(null);
          context.fillStyle = '#ffffff'; context.fillRect(0, 0, canvas.width, canvas.height);
          context.drawImage(image, 0, 0, canvas.width, canvas.height);
          finish({ bytes: fromDataURL(canvas.toDataURL('image/jpeg', .92)), width: canvas.width, height: canvas.height });
        } catch { finish(null); }
      };
      image.src = url;
    });
  }

  async function renderConfigurationPdf(build, photo) {
    const doc = new ConfigurationPDF(`${build.modelTitle} - configuration ${build.reference}`);
    const ink = [.145,.2,.17], muted = [.35,.40,.36], line = [.85,.88,.85];
    let accent = build.accent || [.19,.36,.27];
    // Preserve the chosen brand hue, while keeping small PDF text dark on paper.
    if (accent.reduce((sum, value) => sum + value, 0) > 1.8) accent = accent.map(value => value * .55);
    const tint = accent.map(value => .945 + value * .055);
    const margin = 42, right = 553, full = right - margin;
    const moneyLabel = value => money.format(amount(value));
    const writeLines = (lines, x, top, size=11, color=ink, bold=false, leading=15) => {
      lines.forEach((text, index) => doc.text(text, x, top+index*leading, size, color, bold));
      return top + lines.length * leading;
    };
    const header = label => {
      doc.page(); doc.text('EMPAVA', margin, 32, 20, ink, true);
      doc.text('CUSTOM STUDIO', margin, 61, 8.5, muted);
      doc.text(build.reference, right, 36, 10, accent, true, 'right');
      doc.text(build.dateLabel, right, 54, 9, muted, false, 'right');
      doc.line(margin, 86, right, line);
      if (label) doc.text(label, margin, 105, 10, accent, true);
    };
    header('YOUR BATHTUB. YOUR WAY.');
    if (build.sample) doc.text('LAYOUT SAMPLE / NOT A LIVE QUOTE', right, 105, 8, muted, true, 'right');
    const titleLines = doc.wrap(build.modelTitle, full, 27, true);
    let y = writeLines(titleLines, margin, 130, 27, ink, true, 33);
    doc.text(build.modelCode + '  /  Custom configuration', margin, y+7, 11, muted);
    y += 38;
    doc.rect(margin, y, full, 222, [.978,.982,.974]);
    if (photo) {
      const image = doc.image(photo.bytes, photo.width, photo.height);
      const scale = Math.min((full-36)/image.width, 202/image.height);
      const width = image.width*scale, height=image.height*scale;
      doc.drawImage(image, margin+(full-width)/2, y+(222-height)/2, width, height);
    } else {
      doc.text('Product preview unavailable', 297.5, y+91, 15, muted, false, 'center');
      doc.text('Your selected options are recorded on the following pages.', 297.5, y+117, 10, muted, false, 'center');
    }
    doc.text(build.sample ? 'Sample image: supplied screenshot crop.' : 'Illustrative preview. Not all selected add-ons are pictured.', margin, y+230, 8.5, muted);
    y += 258;
    const tiles = [['DIMENSIONS',build.sizeLabel],['EXTERIOR FINISH',build.colorLabel],['MASSAGE',build.jetLabel]];
    const tileWidth = (full-36)/3;
    let tallest = 0;
    tiles.forEach(([label,value],index) => {
      const x=margin+index*(tileWidth+18), lines=doc.wrap(value,tileWidth,11.5,true);
      doc.text(label,x,y,8.5,muted,true);
      writeLines(lines,x,y+20,11.5,ink,true,16);
      tallest=Math.max(tallest,lines.length*16);
    });
    y += tallest+43;
    doc.rect(margin,y,full,79,tint);
    doc.rect(margin,y,3,79,accent);
    doc.text('CONFIGURATION ESTIMATE',margin+19,y+16,9,accent,true);
    doc.text(moneyLabel(build.total),margin+19,y+34,27,ink,true);
    doc.text('USD',right-20,y+19,9,muted,true,'right');
    doc.text('Final amount confirmed in cart',right-20,y+44,10,muted,false,'right');
    y += 102;
    doc.text('Base bathtub',margin,y,10,muted);
    doc.text(moneyLabel(build.basePrice),margin+190,y,11,ink,true,'right');
    doc.text('Finishes, hardware & add-ons',margin+233,y,10,muted);
    doc.text(moneyLabel(build.total-build.basePrice),right,y,11,ink,true,'right');
    writeLines(doc.wrap('Your selected dimensions, finish, hardware, functions and bundle are itemized on the following pages. Keep this document for your own reference or share it with your installer.', full,10),margin,y+30,10,muted,false,15);

    const pageTop = title => { header('CONFIGURATION DETAILS'); doc.text(title,margin,128,18,ink,true); y=161; };
    pageTop('The details that make it yours.');
    const groupHead = (group, continued=false) => {
      doc.rect(margin,y,full,28,tint);
      doc.text(group + (continued ? ' / continued' : ''),margin+10,y+7,11,accent,true);
      y+=36;
      doc.text('OPTION',margin+10,y,8,muted,true);
      doc.text('YOUR SELECTION',margin+145,y,8,muted,true);
      doc.text('PRICE (USD)',right-10,y,8,muted,true,'right');
      y+=21;
    };
    const nextDetailPage = () => { header('CONFIGURATION DETAILS'); y=133; };
    for (const group of build.groups) {
      if (!group.items.length) continue;
      if (y+107>748) nextDetailPage();
      groupHead(group.title);
      for (const [rowIndex,row] of group.items.entries()) {
        const functionRow=row.key.startsWith('function:');
        const label=functionRow ? 'Add-on '+String(rowIndex+1).padStart(2,'0') : row.key==='bundle' ? 'Bundle' : row.label;
        const labels=doc.wrap(label,121,10), values=doc.wrap(row.val,255,11,true);
        let offset=0;
        const count=Math.max(labels.length,values.length);
        while (offset<count) {
          if (y+48>748) { nextDetailPage(); groupHead(group.title,true); }
          const capacity=Math.max(1,Math.floor((748-y-18)/15));
          let take=Math.min(count-offset,capacity);
          // Prefer a fresh page to splitting a row that would fit there intact.
          if (offset===0 && take<count && count<=30) {
            nextDetailPage(); groupHead(group.title,true); take=Math.min(count,Math.floor((748-y-18)/15));
          }
          const height=take*15+18;
          if (rowIndex%2===0) doc.rect(margin,y,full,height,[.985,.988,.983]);
          writeLines(labels.slice(offset,offset+take),margin+10,y+8,10,muted,false,15);
          writeLines(values.slice(offset,offset+take),margin+145,y+8,11,ink,true,15);
          if (offset+take>=count) {
            const price=row.price===0 ? 'Included' : (row.key==='size' ? '' : '+')+moneyLabel(row.price);
            doc.text(price,right-10,y+8,10,ink,true,'right');
          }
          doc.line(margin,y+height,right,line,.35);
          y+=height; offset+=take;
        }
      }
      y+=20;
    }
    if (y+169>748) nextDetailPage();
    doc.line(margin,y,right,line); y+=17;
    doc.text('Base bathtub',margin,y,11,muted); doc.text(moneyLabel(build.basePrice),right,y,11,ink,false,'right'); y+=23;
    doc.text('Finishes, hardware & add-ons',margin,y,11,muted); doc.text(moneyLabel(build.total-build.basePrice),right,y,11,ink,false,'right'); y+=29;
    doc.rect(margin,y,full,47,tint);
    doc.text('Configuration estimate',margin+12,y+13,13,ink,true); doc.text(moneyLabel(build.total),right-12,y+10,21,ink,true,'right');
    y+=63;
    doc.link('Specification',build.specUrl,margin,y,accent);
    doc.link('Manual',build.manualUrl,margin+110,y,accent);
    doc.link('Visit configuration page',build.pageUrl,margin+190,y,accent);
    y+=29;
    const notesText = [
      build.leadTime ? `Lead time: ${build.leadTime}` : '',
      'Configuration estimate only, not an order or an installation drawing. Pricing and availability must be confirmed in cart. Preview images may not show every add-on. The reference identifies this PDF snapshot; it is not an online restore code.'
    ].filter(Boolean).join(' ');
    const notes=doc.wrap(notesText,full,9);
    if (y+notes.length*13>758) { nextDetailPage(); }
    writeLines(notes,margin,y,9,muted,false,13);
    for (const [index,page] of doc.pages.entries()) {
      doc.current=page; doc.line(margin,789,right,line);
      doc.text(build.sample ? 'EMPAVA / LAYOUT SAMPLE - NOT A QUOTE' : 'EMPAVA / CUSTOM CONFIGURATION',margin,803,8,muted);
      doc.text(`${build.reference}  /  ${index+1} of ${doc.pages.length}`,right,803,8,muted,false,'right');
    }
    return doc.blob();
  }

  // Optional draft persistence. Prices, variant IDs, images, email and feedback
  // are NEVER stored. Only selection identifiers are restored against today's data.
  function refreshThemeCart(openDrawer = false) {
    // EMPAVA uses Maestrooo Impact 5.2.0. Impact listens for cart:refresh on
    // documentElement; the drawer itself is the <cart-drawer> web component.
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    if (!openDrawer) return;

    const openImpactDrawer = () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.show === 'function') {
        drawer.show();
        return true;
      }

      // Impact header cart links normally point at the drawer through
      // aria-controls="cart-drawer". Let the theme handle focus/overlay.
      const trigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (trigger && typeof trigger.click === 'function') {
        trigger.click();
        return true;
      }
      return false;
    };

    // Give Impact's cart:refresh handler a short moment to refresh the drawer
    // markup before opening it. One retry covers slower section refreshes.
    window.setTimeout(() => {
      if (!openImpactDrawer()) window.setTimeout(openImpactDrawer, 180);
    }, 90);
  }

  function formatDeliveryDate(dateInput, monthsToAdd) {
    const date = new Date(dateInput);
    const months = Number(monthsToAdd);
    date.setMonth(date.getMonth() + (Number.isFinite(months) ? months : 0));
    const day = date.getDate();
    const monthNames = [
      'January','February','March','April','May','June',
      'July','August','September','October','November','December'
    ];
    const suffix = (day === 1 || day === 21 || day === 31) ? 'st'
      : (day === 2 || day === 22) ? 'nd'
      : (day === 3 || day === 23) ? 'rd' : 'th';
    return `${day}${suffix} ${monthNames[date.getMonth()]}`;
  }

  function normalizeIp(value) {
    const text = String(value ?? '').trim();
    if (!text || text.length > 80 || /[\r\n<>]/.test(text)) return '';
    return text;
  }

  async function resolveVisitorIp(liquid) {
    if (liquid.captureVisitorIp !== true) return '';

    const existing = normalizeIp(window.data_ip);
    if (existing) return existing;

    const lookupUrl = String(liquid.ipLookupUrl || '').trim();
    if (!/^https:\/\//i.test(lookupUrl)) return '';

    const controller = typeof AbortController === 'function' ? new AbortController() : null;
    const timeout = controller ? window.setTimeout(() => controller.abort(), 2200) : null;
    try {
      const response = await fetch(lookupUrl, {
        method: 'GET',
        credentials: 'omit',
        cache: 'no-store',
        headers: { Accept: 'application/json, text/plain;q=0.9' },
        signal: controller?.signal
      });
      if (!response.ok) return '';
      const type = response.headers.get('content-type') || '';
      if (type.includes('application/json')) {
        const payload = await response.json().catch(() => ({}));
        return normalizeIp(payload?.ip ?? payload?.query ?? payload?.address ?? '');
      }
      return normalizeIp(await response.text());
    } catch (error) {
      if (error?.name !== 'AbortError') console.warn('[EmpavaCustomApp] Visitor IP lookup failed.', error);
      return '';
    } finally {
      if (timeout) window.clearTimeout(timeout);
    }
  }

  async function buildCartMetadata(liquid) {
    const now = new Date();
    const metadata = {
      _get_tp: String(now.getTime()),
      'Delivery Start Time': formatDeliveryDate(now.getTime(), liquid.deliveryStartMonths),
      'Delivery End Time': formatDeliveryDate(now.getTime(), liquid.deliveryEndMonths)
    };
    const ip = await resolveVisitorIp(liquid);
    if (ip) metadata._get_ip = ip;
    return metadata;
  }

  function configurationStore(liquid) {
    const mode = ['session','local'].includes(liquid.saveMode) ? liquid.saveMode : 'off';
    const key = 'empava:custom-studio:v4:' + location.pathname + ':' + String(liquid.sectionId || 'default');
    let failed = false;
    const storage = () => mode === 'local' ? window.localStorage : window.sessionStorage;
    const clear = () => { if (mode === 'off') return; try { storage().removeItem(key); } catch { failed = true; } };
    return {
      mode,
      get failed() { return failed; },
      read() {
        if (mode === 'off') return null;
        try {
          const text = storage().getItem(key);
          if (!text) return null;
          if (text.length > 32768) { clear(); return null; }
          const value = JSON.parse(text);
          if (value.version !== 1 || !Number.isFinite(value.expiresAt) || value.expiresAt <= Date.now()
              || typeof value.sku !== 'string' || !Array.isArray(value.functions)
              || !Array.isArray(value.hardware)) { clear(); return null; }
          return value;
        } catch { failed = true; return null; }
      },
      write(app) {
        if (mode === 'off' || !app.config.sku) return false;
        try {
          const value = {
            version: 1, expiresAt: Date.now() + 7*24*60*60*1000,
            sku: app.config.sku, size: app.config.size, color: app.config.color, jet: app.config.jet,
            functions: [...app.config.functions], bundle: Boolean(app.bundleSelected),
            hardware: Object.entries(app.config.dynHw).map(([category, option]) => [category, String(option.id)])
          };
          storage().setItem(key, JSON.stringify(value)); failed = false; return true;
        } catch { failed = true; return false; }
      }, clear
    };
  }


  // Stage 1: connect the five existing model templates to Shopify product blocks.
  // The template retains image/document/option rules; price and variant ID come
  // ONLY from the selected product. Never infer a purchasable ID from a SKU.
  function parseBaseSku(value) {
    const original = typeof value === 'string' ? value : '';
    const compact = original.trim().replace(/\s+/g, '');
    const match = /^(Master\d+)_(\d+(?:\.\d+)?)[x\u00d7](\d+(?:\.\d+)?)[x\u00d7](\d+(?:\.\d+)?)$/i.exec(compact);
    if (!match || match.slice(2).some(part => Number(part) <= 0)) return null;
    return { modelKey: match[1].toLowerCase(), size: match.slice(2).join('X'), sku: original };
  }

  function connectBaseProducts(raw, templates, currency = 'USD') {
    const enabled = raw !== undefined;
    const issues = [];
    const warn = (blockId, message) => issues.push({ key: String(issues.length), blockId: String(blockId || ''), message });
    if (!enabled) return { enabled: false, models: templates, issues };
    if (!Array.isArray(raw)) {
      warn('', 'Invalid base product data. Replace the section and JS with the matching files.');
      return { enabled: true, models: [], issues };
    }
    // Existing add-on catalog and PDF are USD. Do not mix presentment prices
    // with the old USD add-on amounts; currency conversion is a separate step.
    if (currency !== 'USD') {
      warn('', 'This configurator currently supports USD. Select USD and reload before testing.');
      return { enabled: true, models: [], issues };
    }
    if (!raw.length) warn('', 'Add a Main product block and select a Shopify bathtub product.');
    const byModel = new Map(templates.map(model => [model.id.toLowerCase(), model]));
    const seenProducts = new Set();
    const candidates = [];
    for (const entry of raw) {
      const blockId = String(entry?.blockId || '');
      const productId = String(entry?.productId || '');
      const title = String(entry?.title || 'Unselected block');
      if (!/^[1-9]\d*$/.test(productId)) {
        warn(blockId, 'Select a visible Shopify product in this Main product block.');
        continue;
      }
      if (seenProducts.has(productId)) {
        warn(blockId, `${title}: the same product is already selected in another block; this duplicate is ignored.`);
        continue;
      }
      seenProducts.add(productId);
      const variants = Array.isArray(entry.variants) ? entry.variants : [];
      // The linked products have 1-3 variants. Explicitly reject a truncated
      // array rather than publishing only part of a larger product.
      if (!variants.length || Number(entry.variantCount) !== variants.length) {
        warn(blockId, `${title}: variant data is empty or incomplete. Check the selected product.`);
        continue;
      }
      let preset = null;
      let invalid = false;
      const sizes = [];
      const sizeIds = new Set();
      const variantIds = new Set();
      for (const variant of variants) {
        const parsed = parseBaseSku(variant?.sku);
        const model = parsed && byModel.get(parsed.modelKey);
        const id = String(variant?.id || '');
        if (!model) {
          warn(blockId, `${title}: unsupported or missing SKU "${String(variant?.sku || '')}". Expected Master367_66X48X24 or another of the five existing models.`);
          invalid = true;
          continue;
        }
        if (preset && preset.id !== model.id) {
          warn(blockId, `${title}: variants contain more than one model prefix. Each Main product block must represent one model.`);
          invalid = true;
          continue;
        }
        preset = model;
        if (!/^[1-9]\d*$/.test(id) || typeof variant.price !== 'number' || !Number.isFinite(variant.price)
            || variant.price < 0 || typeof variant.available !== 'boolean') {
          warn(blockId, `${title}: invalid variant ID, price or availability for ${parsed.sku}.`);
          invalid = true;
          continue;
        }
        if (sizeIds.has(parsed.size) || variantIds.has(id)) {
          warn(blockId, `${title}: duplicate size or variant ID for ${parsed.sku}. One size must map to exactly one variant.`);
          invalid = true;
          continue;
        }
        sizeIds.add(parsed.size);
        variantIds.add(id);
        const existing = model.sizes.find(size => size.id === parsed.size);
        if (!existing) {
          warn(blockId, `${title}: ${parsed.size} is a new size. Its price is connected, but no legacy jet/document preset was found for it.`);
        }
        sizes.push({
          ...(existing || { spec: '', manual: '' }),
          id: parsed.size,
          label: existing?.label || parsed.size.toLowerCase() + ' in',
          price: variant.price,
          sku: parsed.sku, variantId: id, productId, source: 'shopify',
          available: variant.available,
          image: `${CDN.primary}${parsed.sku}.webp`,
          imageMobile: `${CDN.primary}${parsed.sku}_mb.webp`,
          requiresSellingPlan: variant.requiresSellingPlan === true,
          // We sell a single bathtub. Shopify validates final stock/quantity.
          quantityAllowed: (!variant.quantityMin || Number(variant.quantityMin) <= 1)
            && (!variant.quantityIncrement || Number(variant.quantityIncrement) === 1)
            && (variant.quantityMax == null || Number(variant.quantityMax) >= 1)
        });
      }
      if (invalid || !preset || !sizes.length) continue;
      candidates.push({ ...preset, sizes, productId, productTitle: title,
        productUrl: String(entry.url || ''), blockId, source: 'shopify' });
    }
    const counts = new Map();
    const idCounts = new Map();
    candidates.forEach(model => {
      counts.set(model.id, (counts.get(model.id) || 0) + 1);
      model.sizes.forEach(size => idCounts.set(size.variantId, (idCounts.get(size.variantId) || 0) + 1));
    });
    const models = candidates.filter(model => {
      if (counts.get(model.id) > 1 || model.sizes.some(size => idCounts.get(size.variantId) > 1)) {
        warn(model.blockId, `${model.productTitle}: this model or variant is claimed by another product. Both conflicting links are disabled; remove the incorrect block.`);
        return false;
      }
      return true;
    });
    return { enabled: true, models, issues };
  }

  function baseSizeUnavailable(size) {
    return Boolean(size?.source === 'shopify'
      && (!size.available || size.requiresSellingPlan || !size.quantityAllowed));
  }

  // Stage 2: color and Jets products. No static finish/jet price tables.
  const colorKey = value => String(value || '').trim().replace(/\s+/g, ' ')
    .replace(/\s*\+\s*/g, ' + ').toLowerCase();

  function linkedVariant(variant, entry) {
    const variantId = String(variant?.id || '');
    if (!/^[1-9]\d*$/.test(variantId) || typeof variant.price !== 'number'
        || !Number.isFinite(variant.price) || variant.price < 0 || typeof variant.available !== 'boolean') return null;
    const min = Number(variant.quantityMin ?? 1);
    const increment = Number(variant.quantityIncrement ?? 1);
    const max = variant.quantityMax == null ? Infinity : Number(variant.quantityMax);
    return {
      variantId, productId: String(entry.productId), blockId: String(entry.blockId || ''),
      sku: String(variant.sku || ''), price: variant.price, source: 'shopify',
      available: variant.available, requiresSellingPlan: variant.requiresSellingPlan === true,
      quantityAllowed: min === 1 && increment === 1 && max >= 1
    };
  }

  function swatchUrl(value) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const input = value.trim();
      const base = globalThis.location?.origin || 'https://shop.invalid';
      const url = new URL(input.startsWith('//') ? 'https:' + input : input, base);
      return ['https:', 'http:'].includes(url.protocol) ? url.href : '';
    } catch (_) { return ''; }
  }

  function parseColorSku(value) {
    const match = /^interior_(.+)$/i.exec(String(value || '').trim());
    if (!match || /[\u0000-\u001f\u007f]/.test(match[1])) return null;
    const parts = match[1].split('+').map(part => part.trim().replace(/\s+/g, ' '));
    if (parts.length > 2 || parts.some(part => !part)) return null;
    const id = parts.join(' + ');
    return { id, key: colorKey(id), type: parts.length === 2 ? 'two' : 'single' };
  }

  function connectColorProduct(raw, currency) {
    const result = { colors: [], issues: [], title: '', autoWhite: true, restrictMaster408: true };
    const warn = message => result.issues.push({ key: 'color-' + result.issues.length, message });
    if (!Array.isArray(raw) || raw.length !== 1) {
      warn('Select exactly one Color product block containing your interior_ variants.');
      return result;
    }
    if (currency !== 'USD') { warn('This configurator currently supports USD only.'); return result; }
    const entry = raw[0];
    result.title = String(entry?.title || '');
    result.autoWhite = entry?.autoWhite !== false;
    result.restrictMaster408 = entry?.keepMaster408Rules !== false;
    if (!/^[1-9]\d*$/.test(String(entry?.productId || ''))) {
      warn('Select a visible Shopify product in the Color product block.');
      return result;
    }
    const variants = Array.isArray(entry.variants) ? entry.variants : [];
    if (!variants.length || variants.length > 250 || Number(entry.variantCount) !== variants.length) {
      warn('Color product data is empty or incomplete. Up to 250 loaded variants per product are supported.');
      return result;
    }
    const candidates = [];
    for (const variant of variants) {
      const parsed = parseColorSku(variant?.sku);
      const live = linkedVariant(variant, entry);
      if (!parsed || !live) {
        warn(`Skipped invalid color variant: ${String(variant?.sku || '(empty SKU)')}. Expected interior_Color name.`);
        continue;
      }
      candidates.push({ ...parsed, ...live,
        label: String(variant.title && variant.title !== 'Default Title' ? variant.title : parsed.id),
        img: swatchUrl(variant.img) });
    }
    const counts = new Map(), ids = new Map();
    candidates.forEach(item => {
      counts.set(item.key, (counts.get(item.key) || 0) + 1);
      ids.set(item.variantId, (ids.get(item.variantId) || 0) + 1);
    });
    result.colors = candidates.filter(item => {
      if (counts.get(item.key) > 1 || ids.get(item.variantId) > 1) {
        warn(`${item.sku}: conflicting color name or variant ID. Both conflicting links are disabled.`);
        return false;
      }
      if (!item.img) warn(`${item.sku}: no swatch image. The name is shown; no shade is guessed.`);
      return true;
    });
    return result;
  }

  // Jets use the same model/size keys as the connected base products.
  function parseJetScope(value) {
    const match = /^(Master\d+)_(\d+(?:\.\d+)?)[x\u00d7](\d+(?:\.\d+)?)[x\u00d7](\d+(?:\.\d+)?)$/i
      .exec(String(value || '').trim().replace(/\s+/g, ''));
    if (!match || match.slice(2).some(part => Number(part) <= 0)) return null;
    const modelId = 'Master' + match[1].replace(/^Master/i, '');
    const size = match.slice(2).join('X');
    return { modelId, modelKey: modelId.toLowerCase(), size, key: modelId.toLowerCase() + ':' + size, label: modelId + '_' + size };
  }

  function parseJetChoice(value) {
    const parts = String(value || '').trim().split('+');
    if (parts.length < 1 || parts.length > 2) return null;
    const counts = {};
    for (const part of parts) {
      const match = /^([1-9]\d*)\s+(water|air)\s+jets?$/i.exec(part.trim().replace(/\s+/g, ' '));
      if (!match || counts[match[2].toLowerCase()] !== undefined) return null;
      const count = Number(match[1]);
      if (!Number.isSafeInteger(count)) return null;
      counts[match[2].toLowerCase()] = count;
    }
    const id = ['water', 'air'].filter(kind => counts[kind])
      .map(kind => `${counts[kind]} ${kind} jets`).join('+');
    const cat = counts.water && counts.air ? 'combo' : counts.water ? 'hydro' : 'air';
    return { id, label: id, cat };
  }

  function parseJetSku(value) {
    const sku = String(value || '').trim();
    if (/^soaking$/i.test(sku)) return { soaking: true };
    const match = /^(Master\d+_[^_]+)_(.+)$/i.exec(sku);
    if (!match) return null;
    const scope = parseJetScope(match[1]);
    const choice = parseJetChoice(match[2]);
    return scope && choice ? { ...choice, scope, soaking: false } : null;
  }

  function connectJetProducts(raw, models, currency) {
    const result = { jets: [], soaking: null, issues: [], scopes: [], parsedCount: 0 };
    const warn = message => result.issues.push({ key: 'jets-' + result.issues.length, message });
    if (!Array.isArray(raw)) { warn('Jets data is missing. Install the matching section and JS.'); return result; }
    if (!raw.length) { warn('Add a Jets product block and select a product.'); return result; }
    if (currency !== 'USD') { warn('This configurator currently supports USD only.'); return result; }
    const modelMap = new Map(models.filter(model => model.source === 'shopify').map(model => [model.id.toLowerCase(), model]));
    const productCounts = new Map();
    raw.forEach(entry => {
      const id = String(entry?.productId || '');
      productCounts.set(id, (productCounts.get(id) || 0) + 1);
    });
    const candidates = [];
    const soakingCandidates = [];
    const scopes = new Map();
    for (const entry of raw) {
      const title = String(entry?.title || 'Jets product');
      const productId = String(entry?.productId || '');
      if (!/^[1-9]\d*$/.test(productId)) { warn('Select a visible Shopify product in each Jets product block.'); continue; }
      if (productCounts.get(productId) > 1) { warn(`${title}: selected in more than one Jets block. Duplicate blocks are disabled.`); continue; }
      const variants = Array.isArray(entry.variants) ? entry.variants : [];
      if (!variants.length || variants.length > 250 || Number(entry.variantCount) !== variants.length) {
        warn(`${title}: variant data is empty or incomplete. Up to 250 loaded variants per product are supported.`);
        continue;
      }
      for (const variant of variants) {
        const parsed = parseJetSku(variant?.sku);
        const live = linkedVariant(variant, entry);
        if (!parsed || !live) { warn(`${title}: invalid Jets SKU or variant data: ${String(variant?.sku || '(empty SKU)')}.`); continue; }
        result.parsedCount += 1;
        if (parsed.soaking) {
          soakingCandidates.push({ ...live, id: 'Soaking', label: 'Soaking', cat: 'soaking', key: 'soaking' });
          continue;
        }
        const model = modelMap.get(parsed.scope.modelKey);
        const target = model?.sizes.find(size => size.id === parsed.scope.size);
        const scopeKey = String(entry.blockId || productId) + ':' + parsed.scope.key;
        if (!scopes.has(scopeKey)) scopes.set(scopeKey, {
          key: scopeKey,
          source: parsed.scope.label,
          sourceModel: parsed.scope.modelKey,
          target: target ? model.id + '_' + target.id : '',
          count: 0,
          status: target ? 'Exact match' : 'Size not linked'
        });
        scopes.get(scopeKey).count += 1;
        if (!target) continue;
        candidates.push({
          ...live,
          id: parsed.id,
          label: parsed.label,
          cat: parsed.cat,
          modelId: model.id,
          size: target.id,
          sourceSize: parsed.scope.size,
          key: model.id + ':' + target.id + ':' + parsed.id
        });
      }
    }
    result.scopes = [...scopes.values()];
    result.scopes.filter(scope => !scope.target).forEach(scope => {
      warn(`${scope.source}: ${scope.count} Jets variants have no exact matching main-product size. Check the SKU or the connected Main product.`);
    });
    const keys = new Map(), ids = new Map();
    candidates.forEach(jet => {
      keys.set(jet.key, (keys.get(jet.key) || 0) + 1);
      ids.set(jet.variantId, (ids.get(jet.variantId) || 0) + 1);
    });
    result.jets = candidates.filter(jet => {
      if (keys.get(jet.key) > 1 || ids.get(jet.variantId) > 1) {
        warn(`${jet.sku}: duplicate model/size/jet combination or variant ID. Conflicting links are disabled.`);
        return false;
      }
      return true;
    });
    if (soakingCandidates.length > 1) {
      warn('More than one Jets variant uses SKU "soaking". The Soaking purchase link is disabled until the duplicate is removed.');
    } else if (soakingCandidates.length === 1) {
      result.soaking = soakingCandidates[0];
      if (amount(result.soaking.price) !== 0) {
        warn(`The soaking variant is priced at ${money.format(amount(result.soaking.price))}. The configurator will display and use that live price; set it to $0.00 in Shopify if Soaking should be included.`);
      }
    } else {
      warn('No Jets variant with SKU "soaking" was found. Soaking remains visible but cannot be added as a linked Jets product until that SKU is present.');
    }
    return result;
  }

  const LINKED_HARDWARE_META = {
    faucet: { category: 'Faucet color' },
    headrest: { category: 'Headrest color' },
    drainCap: { category: 'Drain Cap Finish' },
    nozzle: { category: 'Nozzle Color' },
    drainLocation: { category: 'Drain Location' },
    pillow: { category: 'Pillow position' }
  };

  function normalizeHardwareLabel(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function parseLinkedHardwareSku(kind, value) {
    const sku = String(value || '').trim();
    let match;
    if (kind === 'faucet') {
      match = /^F_(.+)$/i.exec(sku);
      if (!match) return null;
      const id = normalizeHardwareLabel(match[1]);
      return id ? { id, label: id } : null;
    }
    if (kind === 'headrest') {
      match = /^Headrest_(.+)$/i.exec(sku);
      if (!match) return null;
      const id = normalizeHardwareLabel(match[1]);
      return id ? { id, label: id } : null;
    }
    if (kind === 'drainCap') {
      match = /^D_(.+)$/i.exec(sku);
      if (!match) return null;
      const id = normalizeHardwareLabel(match[1]);
      return id ? { id, label: id } : null;
    }
    if (kind === 'nozzle') {
      match = /^NC_(.+)$/i.exec(sku);
      if (!match) return null;
      const id = normalizeHardwareLabel(match[1]);
      return id ? { id, label: id } : null;
    }
    if (kind === 'drainLocation') {
      match = /^sku_(left|center|right)$/i.exec(sku);
      if (!match) return null;
      const id = match[1].toLowerCase();
      return { id, label: id.charAt(0).toUpperCase() + id.slice(1) };
    }
    if (kind === 'pillow') {
      match = /^(Master\d+)-(.+)$/i.exec(sku);
      if (!match) return null;
      const modelId = 'Master' + match[1].replace(/^Master/i, '');
      const id = normalizeHardwareLabel(match[2]);
      return id ? { id, label: id, modelId } : null;
    }
    return null;
  }

  function connectHardwareProducts(raw, currency) {
    const result = { groups: [], issues: [], linkedCount: 0 };
    const warn = message => result.issues.push({ key: 'hardware-' + result.issues.length, message });
    if (!Array.isArray(raw)) return result;
    if (currency !== 'USD' && raw.length) {
      warn('Linked hardware products currently support USD only.');
      return result;
    }

    const kindCounts = new Map();
    raw.forEach(entry => {
      const kind = String(entry?.kind || '');
      kindCounts.set(kind, (kindCounts.get(kind) || 0) + 1);
    });

    for (const entry of raw) {
      const kind = String(entry?.kind || '');
      const meta = LINKED_HARDWARE_META[kind];
      if (!meta) continue;
      const category = meta.category;
      // Presence of a dedicated Block intentionally replaces the old static category,
      // even if the merchant later breaks a SKU. This avoids silently charging stale prices.
      result.groups.push({ category, showFor: 'all', options: [], replaceStatic: true, linkedKind: kind });

      const productId = String(entry?.productId || '');
      const title = String(entry?.title || category);
      if (kindCounts.get(kind) > 1) {
        warn(`${category}: more than one dedicated Block is configured. Keep only one.`);
        continue;
      }
      if (!/^[1-9]\d*$/.test(productId)) {
        warn(`${category}: select a visible Shopify product in its Block.`);
        continue;
      }
      const variants = Array.isArray(entry.variants) ? entry.variants : [];
      if (!variants.length || variants.length > 250 || Number(entry.variantCount) !== variants.length) {
        warn(`${category}: product variant data is empty or incomplete. Up to 250 loaded variants are supported.`);
        continue;
      }

      const byScope = new Map();
      const dedupe = new Map();
      const idCounts = new Map();
      const candidates = [];
      for (const variant of variants) {
        const parsed = parseLinkedHardwareSku(kind, variant?.sku);
        const live = linkedVariant(variant, entry);
        if (!parsed || !live) {
          warn(`${category}: skipped invalid SKU or variant data: ${String(variant?.sku || '(empty SKU)')}.`);
          continue;
        }
        const scope = kind === 'pillow' ? parsed.modelId : 'all';
        const key = `${scope}:${parsed.id.toLowerCase()}`;
        dedupe.set(key, (dedupe.get(key) || 0) + 1);
        idCounts.set(live.variantId, (idCounts.get(live.variantId) || 0) + 1);
        candidates.push({ ...parsed, ...live, scope, key,
          img: kind === 'drainCap' ? swatchUrl(variant.img) : '' });
      }

      for (const item of candidates) {
        if (dedupe.get(item.key) > 1 || idCounts.get(item.variantId) > 1) {
          warn(`${item.sku}: duplicate option or variant ID. Conflicting links are disabled.`);
          continue;
        }
        if (kind === 'drainCap' && !item.img) {
          warn(`${item.sku}: no variant image. Drain Cap Finish expects a Shopify variant image.`);
        }
        const scopeKey = item.scope;
        if (!byScope.has(scopeKey)) byScope.set(scopeKey, []);
        const linkedOption = { ...item };
        // Pillow SKUs contain their model prefix. Other dedicated Hardware products
        // inherit model restrictions from STATIC_DATA during merge below. Do not write
        // showForModels: undefined here because it would erase those restrictions.
        if (kind === 'pillow') linkedOption.showForModels = [item.modelId];
        byScope.get(scopeKey).push(linkedOption);
        result.linkedCount += 1;
      }

      for (const [scope, options] of byScope) {
        result.groups.push({
          category,
          showFor: scope === 'all' ? 'all' : [scope],
          options,
          replaceStatic: false,
          linkedKind: kind
        });
      }
    }
    return result;
  }



  function parseFunctionModels(value) {
    return [...new Set(String(value || '')
      .split(/[,;\n]+/)
      .map(item => item.trim())
      .filter(Boolean))];
  }

  function youtubeVideoId(value) {
    const raw = String(value || '').trim();
    if (!raw) return '';
    if (isVideoId(raw)) return raw;
    try {
      const url = new URL(raw.startsWith('//') ? 'https:' + raw : raw);
      const host = url.hostname.replace(/^www\./i, '').toLowerCase();
      let id = '';
      if (host === 'youtu.be') id = url.pathname.split('/').filter(Boolean)[0] || '';
      else if (host.endsWith('youtube.com')) {
        id = url.searchParams.get('v') || '';
        if (!id) {
          const parts = url.pathname.split('/').filter(Boolean);
          const index = parts.findIndex(part => ['embed', 'shorts', 'live'].includes(part));
          if (index >= 0) id = parts[index + 1] || '';
        }
      }
      return isVideoId(id) ? id : '';
    } catch (_) { return ''; }
  }

  function connectFunctionProducts(raw, currency) {
    const result = { enabled: Array.isArray(raw) && raw.length > 0, functions: [], issues: [], linkedCount: 0 };
    const warn = message => result.issues.push({ key: 'function-' + result.issues.length, message });
    if (!result.enabled) return result;
    if (currency !== 'USD') {
      warn('Linked Function products currently support USD only.');
      return result;
    }
    if (raw.length !== 1) {
      warn('Select exactly one Functions product block.');
      return result;
    }

    const entry = raw[0] || {};
    const productId = String(entry.productId || '');
    const title = String(entry.title || 'Functions');
    if (!/^[1-9]\d*$/.test(productId)) {
      warn('Functions: select a visible Shopify product in the Functions block.');
      return result;
    }
    const variants = Array.isArray(entry.variants) ? entry.variants : [];
    if (!variants.length || variants.length > 250 || Number(entry.variantCount) !== variants.length) {
      warn(`${title}: product variant data is empty or incomplete. Up to 250 loaded variants are supported.`);
      return result;
    }

    const skuCounts = new Map();
    const idCounts = new Map();
    const candidates = [];
    variants.forEach(variant => {
      const sku = String(variant?.sku || '').trim();
      const live = linkedVariant(variant, entry);
      if (!sku || !live) {
        warn(`${title}: skipped Function with an empty SKU or invalid variant data.`);
        return;
      }
      skuCounts.set(sku, (skuCounts.get(sku) || 0) + 1);
      idCounts.set(live.variantId, (idCounts.get(live.variantId) || 0) + 1);
      const rawVideo = String(variant.videoUrl || '').trim();
      const videoId = youtubeVideoId(rawVideo);
      if (rawVideo && !videoId) warn(`${sku}: Video URL is not a supported YouTube URL.`);
      const detailsLink = swatchUrl(variant.detailsUrl);
      if (variant.detailsUrl && !detailsLink) warn(`${sku}: Details / Blog URL is not a valid http(s) URL.`);
      const img = swatchUrl(variant.previewImage);
      const variantImg = swatchUrl(variant.variantImg);
      const models = parseFunctionModels(variant.models);
      const knownModels = new Set(STATIC_DATA.models.map(model => model.id));
      const unknownModels = models.filter(model => !knownModels.has(model));
      if (unknownModels.length) warn(`${sku}: unknown Applicable models value(s): ${unknownModels.join(', ')}.`);
      candidates.push({
        ...live,
        id: sku,
        sku,
        label: String(variant.label || '').trim() || sku,
        desc: String(variant.description || '').trim(),
        isHot: variant.hot === true,
        detailsLink,
        videoId,
        img,
        variantImg,
        models,
        bundleSku: String(variant.bundleSku || '').trim(),
        bundleOnly: variant.bundleOnly === true,
        requiresJets: variant.requiresJets === true,
        visible: variant.visible !== false,
        compareAtPrice: amount(variant.compareAtPrice),
        source: 'shopify'
      });
    });

    const functions = candidates.filter(item => {
      if (skuCounts.get(item.sku) > 1 || idCounts.get(item.variantId) > 1) {
        warn(`${item.sku}: duplicate Function SKU or variant ID. Conflicting links are disabled.`);
        return false;
      }
      return true;
    });
    const bySku = new Map(functions.map(item => [item.sku, item]));
    functions.forEach(item => {
      if (!item.bundleSku) return;
      const bundle = bySku.get(item.bundleSku);
      if (!bundle) {
        warn(`${item.sku}: Bundle SKU ${item.bundleSku} was not found in the Functions product.`);
        return;
      }
      if (!bundle.bundleOnly) warn(`${bundle.sku}: this linked bundle should have Bundle only = true.`);
      item.bundleId = bundle.label || bundle.sku;
      item.bundleSku = bundle.sku;
      item.bundleVariantId = bundle.variantId;
      item.bundlePrice = amount(bundle.price);
      item.bundleOrigPrice = amount(bundle.compareAtPrice);
      item.bundleImg = bundle.img || bundle.variantImg || '';
      item.bundleAvailable = !baseSizeUnavailable(bundle);
      item.hasBundle = item.bundleAvailable;
      if (!item.bundleAvailable) warn(`${bundle.sku}: linked bundle is currently unavailable, so the bundle offer is hidden.`);
    });

    result.functions = functions;
    result.linkedCount = functions.length;
    return result;
  }

  function createApp(root) {
    const host = root.closest(TAG);
    const json = host.querySelector('script[data-empava-config]');
    if (!json) throw new Error('The configurator JSON data block is missing.');
    const liquid = JSON.parse(json.textContent);
    const data = clone(STATIC_DATA);
    const baseCatalog = connectBaseProducts(liquid.baseProducts, data.models, String(liquid.currency || 'USD'));
    data.models = baseCatalog.models;
    const colorCatalog = connectColorProduct(liquid.colorProducts, String(liquid.currency || 'USD'));
    const jetCatalog = connectJetProducts(liquid.jetProducts, data.models, String(liquid.currency || 'USD'));
    const hardwareCatalog = connectHardwareProducts(liquid.hardwareProducts, String(liquid.currency || 'USD'));
    const functionCatalog = connectFunctionProducts(liquid.functionProducts, String(liquid.currency || 'USD'));
    data.colors = colorCatalog.colors;
    data.rawJets = jetCatalog.jets;
    if (functionCatalog.enabled) data.functions = functionCatalog.functions;
    const variantMap = new Map();
    const ambiguousSkus = new Set();
    (liquid.variants || []).forEach(variant => {
      const sku = String(variant.sku || '');
      const id = String(variant.id || '');
      if (!sku || !id) return;
      if (variantMap.has(sku) && variantMap.get(sku) !== id) ambiguousSkus.add(sku);
      else variantMap.set(sku, id);
    });
    const legacyHardware = (liquid.liquidHardware || []).map(group => ({
      ...group,
      category: String(group.category || '').trim(),
      showFor: group.showFor || group.skus || 'all',
      options: (group.options || []).map(normalizeOption)
    })).filter(group => group.category);
    const linkedHardware = hardwareCatalog.groups.map(group => ({
      ...group,
      category: String(group.category || '').trim(),
      showFor: group.showFor || 'all',
      options: (group.options || []).map(normalizeOption)
    })).filter(group => group.category);
    // Dedicated hardware Blocks come last so they override legacy/static data.
    const customHardware = [...legacyHardware, ...linkedHardware];

    const draftStore = configurationStore(liquid);
    let restoringDraft = false, clearedDraftSignature = null;
    let pdfURL = '', pdfAbort;
    let draftPageHide;
    const owner = {};
    let header;
    let image;
    let imageSequence = 0;
    let feedbackTimer;
    let featureVideo;
    let dialogs;
    let uiScrollFrame = 0;
    let uiScrollHandler;
    let toastTimer;
    let destroyed = false;
    let headerObserver;
    const previousTop = root.style.getPropertyValue('--empava-app-top');
    const previousTopPriority = root.style.getPropertyPriority('--empava-app-top');
    const updateLayoutTop = () => {
      if (destroyed) return;
      const visible = header && getComputedStyle(header).display !== 'none'
        && getComputedStyle(header).visibility !== 'hidden';
      const bottom = visible ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      root.style.setProperty('--empava-app-top', `${Math.round(bottom)}px`);
    };

    return {
      step: 0, model: null, isImgLoading: false, renderedImage: '', isSubmitting: false,
      sizeImgError: false, show360: false, showSummary: false, showFeedback: false,
      frame360: 0, activeFuncTab: null, bundleSelected: false,
      feedbackForm: { score: 8, suit: '', email: '', options: '', information: '', improvements: '', decision: '', experience: '' },
      feedbackQuestions: FEEDBACK_QUESTIONS,
      feedbackSending: false, feedbackAttempted: false, feedbackStatus: '', feedbackMessage: '',
      sections: CONFIG_SECTIONS, activeSection: 'size', showDimensions: true, image360Error: false,
      cartMessage: '', cartIsError: false,
      pdfGenerating: false, pdfMessage: '', pdfIsError: false, pdfDownloadUrl: '', pdfFilename: '',
      savedConfigurationMessage: '', allFunctionDetails: liquid.allFunctionDetails === true,
      config: { sku: '', size: '', color: '', jet: 'Soaking', dynHw: {}, functions: [] },
      models: data.models, colors: data.colors, rawJets: data.rawJets,
      allFunctions: data.functions,
      baseProductsLinked: baseCatalog.enabled,
      baseLinkIssues: baseCatalog.issues,
      baseLinkDesignMode: liquid.designMode === true,
      get connectedBaseCount() { return this.models.filter(model => model.source === 'shopify').length; },
      get connectedSizeCount() { return this.models.reduce((sum, model) => sum + model.sizes.length, 0); },
      isBaseSizeUnavailable(size) { return baseSizeUnavailable(size); },
      baseSizeStatus(size) {
        if (size?.requiresSellingPlan) return 'Purchase plan required';
        if (size?.quantityAllowed === false) return 'Quantity rule not supported';
        return size?.source === 'shopify' && !size.available ? 'Currently unavailable' : 'Base price';
      },
      get baseProductEmptyMessage() {
        return String(liquid.currency || 'USD') !== 'USD'
          ? 'This configurator currently supports USD. Please select USD and reload.'
          : 'No connected bathtub products are available. Please contact us for assistance.';
      },
      // Always resolve the base variant from the current product catalog.
      // Stored drafts and previous SKU-only blocks cannot override this link.
      connectedBaseSize() {
        const model = this.models.find(item => item.id === this.config.sku);
        const size = model?.sizes.find(item => item.id === this.config.size);
        if (!size || (baseCatalog.enabled && size.source !== 'shopify')) {
          throw new Error('The selected base bathtub is not connected. Please select a linked model and size.');
        }
        if (baseSizeUnavailable(size)) throw new Error('This bathtub size is not currently available to buy. Please choose another size.');
        return size;
      },
      buildBaseOnlyTestItems() {
        if (!this.baseLinkDesignMode) throw new Error('The base-only connection test is available only in the theme editor.');
        const size = this.connectedBaseSize();
        if (size.source !== 'shopify') throw new Error('Select a product in a Main product block first.');
        return [{ id: size.variantId, quantity: 1, properties: {
          'Connection test': 'Base bathtub only - no accessories or function add-ons included',
          'Model': this.config.sku, 'Size': size.label, 'Base SKU': size.sku
        } }];
      },

      // Shopify color/Jets catalogs share the existing UI, PDF and cart state.
      colorLinkIssues: colorCatalog.issues,
      colorProductTitle: colorCatalog.title,
      jetLinkIssues: jetCatalog.issues,
      jetScopeAudit: jetCatalog.scopes,
      jetParsedCount: jetCatalog.parsedCount,
      linkedSoaking: jetCatalog.soaking,
      jetSelectionMessage: '',
      previewImageUnavailable: false,
      get connectedColorCount() { return this.colors.length; },
      get connectedSingleColorCount() { return this.colors.filter(color => color.type === 'single').length; },
      get connectedTwoColorCount() { return this.colors.filter(color => color.type === 'two').length; },
      get connectedJetCount() { return this.rawJets.length; },
      get hardwareLinkIssues() { return hardwareCatalog.issues; },
      get connectedHardwareCount() { return hardwareCatalog.linkedCount; },
      functionProductsLinked: functionCatalog.enabled,
      get functionLinkIssues() { return functionCatalog.issues; },
      get connectedFunctionCount() { return functionCatalog.linkedCount; },
      isColorAllowed(color) {
        return Boolean(color && this.config.sku && !(colorCatalog.restrictMaster408
          && this.config.sku === 'Master408' && (color.type === 'two' || color.key === 'pearl white')));
      },
      isColorUnavailable(color) { return !color || baseSizeUnavailable(color); },
      isJetUnavailable(jet) { return !jet || baseSizeUnavailable(jet); },
      linkedOptionStatus(option) {
        if (option?.requiresSellingPlan) return 'Purchase plan required';
        if (option?.quantityAllowed === false) return 'Quantity rule not supported';
        return !option || baseSizeUnavailable(option) ? 'Currently unavailable' : '';
      },
      get colorSelectionMessage() {
        if (!this.colors.length) return 'Color options are not connected yet. Please contact us for assistance.';
        if (!this.config.size) return '';
        if (!this.selectedColor) return 'Please choose a color to complete your configuration.';
        return this.isColorUnavailable(this.selectedColor) ? 'Please choose an available color.' : '';
      },
      get jetsEmptyMessage() {
        if (!this.config.size) return '';
        const hasMassageJets = this.rawJets.some(jet => jet.modelId === this.config.sku && jet.size === this.config.size);
        if (hasMassageJets) return '';
        return this.linkedSoaking
          ? 'No massage Jets are linked for this size. Soaking (no jets) is still available.'
          : 'No Jets are linked for this size, including the soaking variant. Check the Jets product block.';
      },
      syncColor(allowFreeDefault = false) {
        if (this.selectedColor && !this.isColorUnavailable(this.selectedColor)) return;
        this.config.color = '';
        if (allowFreeDefault && colorCatalog.autoWhite) {
          const white = this.colors.find(color => color.key === 'white' && color.price === 0
            && this.isColorAllowed(color) && !this.isColorUnavailable(color));
          if (white) this.config.color = white.id;
        }
      },
      connectedColor() {
        const color = this.selectedColor;
        if (!color || color.source !== 'shopify') throw new Error('Please select a color connected through a Color product block.');
        if (this.isColorUnavailable(color)) throw new Error('This color is not available to buy. Please choose another color.');
        return color;
      },
      connectedJet() {
        if (this.config.jet === 'Soaking') {
          if (!this.linkedSoaking) throw new Error('Connect a Jets product containing the SKU soaking.');
          if (this.isJetUnavailable(this.linkedSoaking)) throw new Error('The linked Soaking variant is not available to buy.');
          return this.linkedSoaking;
        }
        const jet = this.selectedJet;
        if (!jet || jet.source !== 'shopify') throw new Error('Please select a Jets option linked to this exact model and size.');
        if (this.isJetUnavailable(jet)) throw new Error('This Jets option is not available to buy. Please choose another option.');
        return jet;
      },
      buildLinkedOptionsTestItems(includeJets = true) {
        if (!this.baseLinkDesignMode) throw new Error('Connection tests are available only in the theme editor.');
        const base = this.connectedBaseSize();
        if (base.source !== 'shopify') throw new Error('Connect a Main product block first.');
        const color = this.connectedColor();
        const jet = includeJets ? this.connectedJet() : null;
        const binding = 'catalog-test:' + (window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
        const properties = {
          Binding: binding,
          'Connection test': includeJets
            ? 'Main bathtub + color + selected Jets only; other hardware/functions excluded'
            : 'Main bathtub + color only; Jets and all other options excluded',
          Model: this.config.sku, Size: base.label, Color: color.label,
          Jets: includeJets ? jet?.label || 'Soaking' : 'Not part of this test'
        };
        const options = [base, color, ...(includeJets && jet ? [jet] : [])];
        if (new Set(options.map(option => option.variantId)).size !== options.length) {
          throw new Error('The connected products contain conflicting variant IDs.');
        }
        return options.map(option => ({ id: option.variantId, quantity: 1, properties: { ...properties } }));
      },
      async testLinkedOptionsCart(includeJets = true) {
        if (!this.baseLinkDesignMode) return;
        return this.submitCartItems(() => this.buildLinkedOptionsTestItems(includeJets),
          'Connection test added to cart. Only the explicitly listed test items were added; no order was placed.');
      },
      get previewUnavailableMessage() {
        return `The combined preview for ${this.selectedColor?.label || 'this configuration'} could not load. Showing the base model image; your selections and prices are unchanged.`;
      },

      init() {
        featureVideo = createFeatureVideoController(root);
        dialogs = createDialogController(root, (name, open) => {
          const field = { summary: 'showSummary', feedback: 'showFeedback', view360: 'show360' }[name];
          if (field) this[field] = open;
        });
        uiScrollHandler = () => {
          if (uiScrollFrame || destroyed) return;
          uiScrollFrame = requestAnimationFrame(() => {
            uiScrollFrame = 0;
            if (destroyed || this.step !== 1) return;
            const boundary = root.querySelector('[data-ec-nav]')?.getBoundingClientRect().bottom || 0;
            let active = 'size';
            root.querySelectorAll('[data-config-section]').forEach(section => {
              if (section.getBoundingClientRect().top <= boundary + 90) active = section.dataset.configSection;
            });
            this.activeSection = active;
          });
        };
        root.addEventListener('scroll', uiScrollHandler, true);
        header = document.getElementById('shopify-section-sections--20225219461340__mega_menu_new')
          || document.querySelector('.shopify-section--mega_menu_new');
        setPageLayoutLock(owner, true);
        this.$watch('step', step => {
          setHeaderLock(header, owner, step === 1);
          updateLayoutTop();
        });
        updateLayoutTop();
        window.addEventListener('resize', updateLayoutTop, { passive: true });
        if (header && typeof ResizeObserver !== 'undefined') {
          headerObserver = new ResizeObserver(updateLayoutTop);
          headerObserver.observe(header);
        }
        this.$watch('mainImageUrl', url => this.loadMainImage(url));
        this.$watch('config.size', () => { this.sizeImgError = false; });
        this.$watch('frame360', () => { this.image360Error = false; });
        this.restoreConfiguration();
        this.$watch('config', () => this.persistConfiguration());
        this.$watch('bundleSelected', () => this.persistConfiguration());
        draftPageHide = () => this.persistConfiguration();
        window.addEventListener('pagehide', draftPageHide);
      },

      destroy() {
        this.persistConfiguration();
        window.removeEventListener('pagehide', draftPageHide);
        pdfAbort?.abort();
        if (pdfURL) URL.revokeObjectURL(pdfURL);
        featureVideo?.destroy();
        dialogs?.destroy();
        root.removeEventListener('scroll', uiScrollHandler, true);
        cancelAnimationFrame(uiScrollFrame);
        clearTimeout(toastTimer);
        destroyed = true;
        imageSequence += 1;
        if (image) image.onload = image.onerror = null;
        clearTimeout(feedbackTimer);
        setHeaderLock(header, owner, false);
        setPageLayoutLock(owner, false);
        window.removeEventListener('resize', updateLayoutTop);
        headerObserver?.disconnect();
        if (previousTop) root.style.setProperty('--empava-app-top', previousTop, previousTopPriority);
        else root.style.removeProperty('--empava-app-top');
      },


      // Current configuration -> immutable snapshot -> downloadable PDF.
      // Export never selects an item, posts feedback or changes the shopping cart.
      configurationSnapshot() {
        if (!this.selectedSize) throw new Error('Please select a size before creating your configuration PDF.');
        this.connectedColor();
        this.connectedJet();
        const rows = clone(this.summaryDetails);
        const sum = Math.round(rows.reduce((total, row) => total + amount(row.price), 0)*100)/100;
        if (Math.abs(sum - this.totalPrice) > .01) throw new Error('The configuration totals do not match. Please review your selections.');
        const groups = [
          {title: '01 / Base & dimensions', items: rows.filter(row => row.key === 'size')},
          {title: '02 / Finish & massage', items: rows.filter(row => ['color','jet'].includes(row.key))},
          {title: '03 / Hardware & placement', items: rows.filter(row => row.key.startsWith('hardware:'))},
          {title: '04 / Function add-ons', items: rows.filter(row => row.key.startsWith('function:') || row.key === 'bundle')}
        ];
        const serialized = JSON.stringify([this.model.id, rows]);
        let hash = 2166136261;
        for (let i=0;i<serialized.length;i++) { hash ^= serialized.charCodeAt(i); hash = Math.imul(hash,16777619); }
        const reference = 'EMP-' + (hash >>> 0).toString(36).toUpperCase().padStart(7,'0');
        const date = new Date();
        return {
          reference, dateLabel: new Intl.DateTimeFormat('en-US',{dateStyle:'medium',timeStyle:'short'}).format(date),
          createdAt: date.toISOString(), modelTitle: this.model.title,
          modelCode: this.config.sku,
          sizeLabel: this.selectedSize.label, colorLabel: this.selectedColor?.label || this.config.color,
          jetLabel: this.config.jet, basePrice: this.prices.size, total: this.totalPrice, groups,
          // Use the requested combined bathtub image, NOT a last-loaded image or
          // an open feature image. If unavailable, export a clear placeholder.
          imageUrl: this.mainImageUrl, specUrl: this.specUrl, manualUrl: this.manualUrl,
          leadTime: String(liquid.leadTime || '').trim(),
          pageUrl: location.origin + location.pathname,
          accent: pdfRGB(getComputedStyle(root).getPropertyValue('--ea-accent').trim())
        };
      },
      async downloadConfigurationPdf() {
        if (this.pdfGenerating || this.isSubmitting || destroyed) return;
        this.pdfGenerating = true; this.pdfIsError = false;
        this.pdfMessage = 'Creating your configuration PDF...';
        pdfAbort?.abort(); pdfAbort = new AbortController();
        const signal = pdfAbort.signal;
        try {
          const snapshot = this.configurationSnapshot();
          const photo = await configurationPhoto(snapshot.imageUrl, signal);
          if (destroyed || signal.aborted) return;
          const blob = await renderConfigurationPdf(snapshot, photo);
          if (destroyed || signal.aborted) return;
          const url = URL.createObjectURL(blob);
          if (pdfURL) URL.revokeObjectURL(pdfURL);
          pdfURL = url; this.pdfDownloadUrl = url;
          this.pdfFilename = `Empava-${snapshot.modelCode}-${snapshot.reference}-${snapshot.createdAt.slice(0,10)}.pdf`;
          this.pdfMessage = photo
            ? 'Your PDF is ready. It records the choices at the time you clicked Download.'
            : 'Your PDF is ready without the product photo; all selected options and prices are included.';
          // Some mobile browsers open a PDF instead of saving it. Keep a visible,
          // user-clickable Save / Open link inside the summary as a fallback.
          const anchor = document.createElement('a');
          anchor.href = url; anchor.download = this.pdfFilename;
          anchor.textContent = 'Download configuration PDF';
          anchor.hidden = true;
          (root.querySelector('[data-ec-dialog="summary"]') || root).appendChild(anchor);
          anchor.click(); anchor.remove();
        } catch (error) {
          if (!destroyed && !signal.aborted) {
            this.pdfIsError = true;
            this.pdfMessage = error.message || 'The PDF could not be created. Please try again.';
          }
        } finally { if (!destroyed) this.pdfGenerating = false; }
      },
      get saveConfigurationMode() { return draftStore.mode; },
      persistConfiguration() {
        if (destroyed || restoringDraft || draftStore.mode === 'off') return;
        const signature = JSON.stringify([this.config, this.bundleSelected]);
        if (signature === clearedDraftSignature) return;
        clearedDraftSignature = null;
        const saved = draftStore.write(this);
        this.savedConfigurationMessage = saved
          ? (draftStore.mode === 'local' ? 'Configuration saved on this browser for up to 7 days.' : 'Configuration saved for this browser tab.')
          : (draftStore.failed ? 'Browser storage is unavailable. You can still download your configuration PDF.' : '');
      },
      clearSavedConfiguration() {
        draftStore.clear();
        clearedDraftSignature = JSON.stringify([this.config, this.bundleSelected]);
        this.savedConfigurationMessage = 'Saved copy removed. Your current choices are unchanged; new changes will save again.';
      },
      restoreConfiguration() {
        const saved = draftStore.read();
        if (!saved) return;
        const model = this.models.find(item => item.id === saved.sku);
        if (!model) { draftStore.clear(); return; }
        restoringDraft = true;
        try {
          this.selectModel(model);
          const size = model.sizes.find(item => item.id === saved.size && !baseSizeUnavailable(item));
          if (size) this.selectSize(size);
          if (size) {
            const color = this.colors.find(item => item.key === colorKey(saved.color));
            this.config.color = '';
            if (color) this.selectColor(color);
            this.selectJet(saved.jet);
            for (const pair of saved.hardware) {
              if (!Array.isArray(pair) || pair.length !== 2) continue;
              const [category, id] = pair;
              const group = this.validHardwareCats.find(item => item.category === category);
              const option = group?.options.find(item => String(item.id) === id);
              if (option) this.setHardware(category, option);
            }
            this.config.functions = this.activeFunctions.filter(item => saved.functions.includes(item.id)).map(item => item.id);
            this.bundleSelected = saved.bundle === true && this.config.functions.includes(THERMOSTAT)
              && this.thermostat?.hasBundle && this.thermostat.bundleAvailable !== false;
          }
          this.activeFuncTab = null;
          this.savedConfigurationMessage = !this.selectedSize
            ? 'Your saved model was restored, but the previous size is no longer available. Please select a size.'
            : !this.selectedColor || this.jetSelectionMessage
              ? 'Your saved build was restored with updated prices. A color or Jets choice needs review; see its section.'
              : 'Your saved selections were restored. Prices were recalculated from the current page data.';
        } finally { restoringDraft = false; }
      },

      // UI projections: do not mutate summaryDetails used by cart properties.
      get summaryGroups() {
        const rows = this.summaryDetails;
        const definitions = [
          { id: 'base', title: 'Base & dimensions', edit: 'size', test: row => row.key === 'size' },
          { id: 'finish', title: 'Finish & massage', edit: 'color', test: row => ['color', 'jet'].includes(row.key) },
          { id: 'hardware', title: 'Hardware & placement', edit: 'hardware', test: row => row.key.startsWith('hardware:') },
          { id: 'functions', title: 'Function add-ons', edit: 'functions', test: row => row.key.startsWith('function:') || row.key === 'bundle' }
        ];
        return definitions.map(group => {
          const items = rows.filter(group.test).map(row => ({
            ...row,
            displayLabel: row.key.startsWith('function:') ? row.val : row.key === 'bundle' ? 'Thermostat bundle' : row.label,
            displayValue: row.key.startsWith('function:') ? '' : row.val,
            edit: row.key === 'jet' ? 'massage' : row.key === 'color' ? 'color' : group.edit
          }));
          return { ...group, items, total: Math.round(items.reduce((sum, row) => sum + amount(row.price), 0) * 100) / 100 };
        });
      },
      get customizationTotal() { return Math.round((this.totalPrice - this.prices.size) * 100) / 100; },
      priceLabel(value, base = false) {
        return base ? this.formatMoney(value) : amount(value) === 0 ? 'Included' : '+' + this.formatMoney(value);
      },
      basePriceFor(model) { return Math.min(...model.sizes.map(size => size.price)); },
      swatchStyle(color) {
        const image = swatchUrl(color?.img);
        return image
          ? `background: transparent url(${JSON.stringify(image)}) center / contain no-repeat; border: 0; border-radius: 0; box-shadow: none;`
          : 'background: var(--ec-soft);';
      },
      openPanel(name, trigger) {
        if (name === 'summary' && !this.selectedSize) return;
        if (name === 'view360' && !this.config.sku) return;
        featureVideo?.close({ restoreFocus: false });
        if (name === 'view360') this.image360Error = false;
        dialogs?.open(name, trigger);
      },
      closePanel(name) { dialogs?.close(name); },
      scrollToSection(id) {
        if (!CONFIG_SECTIONS.some(section => section.id === id)) return;
        dialogs?.closeAll({ restoreFocus: false });
        this.activeSection = id;
        this.$nextTick(() => {
          if (destroyed) return;
          const element = root.querySelector(`[data-config-section="${id}"]`);
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          element?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
          element?.querySelector('[data-ec-section-title]')?.focus({ preventScroll: true });
        });
      },
      scrollToPreview() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        root.querySelector('[data-ec-preview]')?.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      },
      clearCartMessage() { this.cartMessage = ''; },
      get feedbackCompleted() {
        const form = this.feedbackForm;
        const values = [Number.isFinite(Number(form.score)) && form.score >= 0 && form.score <= 10,
          ['difficulty', 'normal', 'easy', 'quick'].includes(form.suit),
          String(form.email).trim().length > 0 && Boolean(root.querySelector('[data-ec-feedback-email]')?.validity.valid),
          ...FEEDBACK_QUESTIONS.map(question => String(form[question.key] || '').trim().length > 0)];
        return values.filter(Boolean).length;
      },
      onFeedbackInvalid() {
        this.feedbackAttempted = true;
        this.feedbackStatus = 'invalid';
        this.feedbackMessage = 'Please complete all required questions and enter a valid email address.';
      },
      submitFeedback(event) {
        const form = event.target;
        if (this.feedbackSending) { event.preventDefault(); return; }
        this.feedbackAttempted = true;
        form.querySelectorAll('textarea[required]').forEach(input => {
          input.setCustomValidity(input.value.trim() ? '' : 'Please enter a response.');
        });
        if (!form.checkValidity()) {
          event.preventDefault(); this.onFeedbackInvalid(); form.reportValidity(); return;
        }
        // Keep the user's native POST, exact field names and hidden iframe target.
        // Never use no-cors fetch or treat an opaque iframe load as success.
        this.feedbackSending = true;
        this.feedbackStatus = 'sending';
        this.feedbackMessage = 'Submitting your feedback...';
        clearTimeout(feedbackTimer);
        feedbackTimer = setTimeout(() => {
          if (destroyed) return;
          this.feedbackSending = false;
          this.feedbackStatus = 'unconfirmed';
          this.feedbackMessage = 'Submission attempted. Receipt could not be confirmed here. Your answers have been kept; please avoid duplicate submissions.';
        }, 15000);
      },
      onFeedbackFrameLoad() {
        if (!this.feedbackSending || destroyed) return;
        clearTimeout(feedbackTimer);
        // This event also fires for error pages; it is not a server acknowledgement.
        this.feedbackStatus = 'unconfirmed';
        this.feedbackMessage = 'Submission attempted. This page cannot verify receipt. Your answers have been kept; please avoid duplicate submissions.';
        // Short cooldown discourages an accidental second POST.
        feedbackTimer = setTimeout(() => { if (!destroyed) this.feedbackSending = false; }, 4000);
      },

      formatMoney(value) { return money.format(amount(value)); },
      get selectedSize() { return this.model?.sizes.find(size => size.id === this.config.size); },
      get selectedColor() {
        return this.colors.find(color => color.id === this.config.color && this.isColorAllowed(color));
      },
      get selectedJet() {
        if (this.config.jet === 'Soaking') return this.linkedSoaking || null;
        return this.rawJets.find(jet => jet.modelId === this.config.sku
          && jet.size === this.config.size && jet.id === this.config.jet);
      },
      get prices() {
        // Prices are derived, so changing size cannot keep an old jet price.
        return {
          size: amount(this.selectedSize?.price),
          color: amount(this.selectedColor?.price),
          jet: amount(this.selectedJet?.price)
        };
      },
      get singleToneColors() { return this.visibleColors('single'); },
      get twoToneColors() { return this.visibleColors('two'); },
      visibleColors(type) {
        return this.colors.filter(color => color.type === type && this.isColorAllowed(color));
      },
      get sizeImageUrl() {
        return this.selectedSize?.image || '';
      },
      get sizeImageMobileUrl() {
        return this.selectedSize?.imageMobile || '';
      },
      get specUrl() { return this.selectedSize?.spec ? `${CDN.docs}${this.selectedSize.spec}` : ''; },
      get manualUrl() { return this.selectedSize?.manual ? `${CDN.docs}${this.selectedSize.manual}` : ''; },
      get image360Url() {
        return this.show360 && this.config.sku
          ? `${CDN.primary}${this.config.sku}_${this.frame360}.webp?v=1706507656` : '';
      },

      getHardwareImage(category, optionId) {
        const sku = this.config.sku;
        const id = String(optionId || '');
        const safe = id.replace(/ /g, '_');
        const matte = id === 'Glossy Black' ? 'Matte_Black' : safe;
        if (category === 'Faucet color') return `${CDN.primary}${sku}_${safe}.webp`;
        if (category === 'Drain Cap Finish') return `${CDN.primary}${matte}.webp`;
        if (category === 'Nozzle Color') return `${CDN.primary}NC_${safe}.webp`;
        if (category === 'Handrails') return `${CDN.docs}${safe}_1.png`;
        const key = `${sku}_${id}`;
        if (category === 'Headrest color') return IMAGE_MAPS.headrest[key] ? `${CDN.primary}${IMAGE_MAPS.headrest[key]}` : '';
        if (category === 'Drain Location') return IMAGE_MAPS.drain[key] ? `${CDN.primary}${IMAGE_MAPS.drain[key]}` : '';
        if (category === 'Pillow position') return IMAGE_MAPS.pillow[key] ? `${CDN.docs}${IMAGE_MAPS.pillow[key]}` : '';
        return '';
      },

      get validHardwareCats() {
        if (!this.config.sku) return [];
        const groups = new Map();
        data.hardwareCats.forEach(group => {
          if (allowedFor(group.showFor, this.config.sku)) {
            groups.set(group.category, { ...group, options: group.options.map(normalizeOption) });
          }
        });

        const customCategories = new Set();
        customHardware.forEach(group => {
          if (!allowedFor(group.showFor, this.config.sku)) return;
          const previous = groups.get(group.category) || { category: group.category, options: [] };
          const defaults = data.hardwareCats.find(item => item.category === group.category);

          if (group.replaceStatic && !customCategories.has(group.category)) {
            groups.set(group.category, { ...previous, ...group, options: [] });
            customCategories.add(group.category);
            if (!group.options.length) return;
          }
          if (!group.options.length) return;

          const normalized = group.options.map(option => {
            const match = defaults?.options.find(item => item.id === option.id || item.label === option.label);
            // Keep the old display label, ordering and model restrictions while replacing
            // price / availability / variantId with live Shopify data.
            if (!match) return option;
            const merged = { ...match, ...option, id: match.id, label: match.label || option.label };
            // A dedicated Shopify Hardware product supplies live price / availability / variantId.
            // The legacy preset still owns display order and per-model applicability unless the
            // linked option explicitly provides a real restriction of its own.
            merged.showForModels = option.showForModels ?? match.showForModels;
            return merged;
          });

          const existing = customCategories.has(group.category) ? (groups.get(group.category)?.options || []) : [];
          const merged = new Map([...existing, ...normalized].map(option => [option.id, option]));
          let ordered = [...merged.values()];
          if (defaults?.options?.length) {
            const order = new Map(defaults.options.map((option, index) => [option.id, index]));
            ordered.sort((a, b) => (order.get(a.id) ?? 999) - (order.get(b.id) ?? 999));
          }
          groups.set(group.category, { ...previous, ...group, options: ordered });
          customCategories.add(group.category);
        });

        return [...groups.values()]
          .filter(group => !(group.dependsOnJet && this.config.jet === 'Soaking'))
          .map(group => {
            const defaults = data.hardwareCats.find(item => item.category === group.category);
            return {
              category: group.category,
              options: group.options.filter(option => {
                const preset = defaults?.options.find(item => item.id === option.id || item.label === option.label);
                const modelRule = option.showForModels ?? preset?.showForModels;
                return allowedFor(modelRule, this.config.sku) && !baseSizeUnavailable(option);
              })
            };
          })
          .filter(group => group.options.length);
      },

      syncHardware() {
        const next = {};
        this.validHardwareCats.forEach(group => {
          const old = this.config.dynHw[group.category];
          next[group.category] = group.options.find(option => option.id === old?.id) || group.options[0];
        });
        this.config.dynHw = next;
      },
      get activeFunctions() {
        if (!this.config.sku) return [];
        return this.allFunctions.filter(func => {
          if (func.visible === false || func.bundleOnly === true || baseSizeUnavailable(func)) return false;
          if ((func.hideFor || []).includes(this.config.sku)) return false;
          if (Array.isArray(func.models) && func.models.length && !func.models.includes(this.config.sku)) return false;
          if (func.requiresJets === true && this.config.jet === 'Soaking') return false;
          return true;
        });
      },
      syncFunctions() {
        const valid = new Set(this.activeFunctions.map(func => func.id));
        this.config.functions = this.config.functions.filter(id => valid.has(id));
        if (this.activeFuncTab && !valid.has(this.activeFuncTab)) this.activeFuncTab = null;
        if (!this.config.functions.includes(THERMOSTAT)) this.bundleSelected = false;
      },
      get selectedFunctions() {
        return this.config.functions.map(id => this.activeFunctions.find(func => func.id === id)).filter(Boolean);
      },
      get thermostat() { return this.allFunctions.find(func => func.id === THERMOSTAT); },
      get activeBundle() {
        const thermostat = this.thermostat;
        return this.bundleSelected && this.config.functions.includes(THERMOSTAT)
          && thermostat?.hasBundle && thermostat.bundleAvailable !== false ? thermostat : null;
      },
      filteredJets(category) {
        return this.rawJets.filter(jet => jet.modelId === this.config.sku
          && jet.size === this.config.size && jet.cat === category);
      },
      get totalPrice() {
        const { size, color, jet } = this.prices;
        const hardware = Object.values(this.config.dynHw).reduce((sum, option) => sum + amount(option.price), 0);
        const functions = this.selectedFunctions.reduce((sum, func) => sum + amount(func.price), 0);
        return Math.round((size + color + jet + hardware + functions + amount(this.activeBundle?.bundlePrice)) * 100) / 100;
      },
      get activeFunction() { return this.activeFunctions.find(func => func.id === this.activeFuncTab); },
      get currentVisualImage() {
        const func = this.activeFunction;
        return func?.img && func.img !== 'none' ? func.img : this.mainImage;
      },
      get activeFunctionDesc() { return this.activeFunction?.desc || ''; },
      get summaryDetails() {
        if (!this.selectedSize) return [];
        const list = [
          { key: 'size', label: 'Size', val: this.selectedSize.label, price: this.prices.size, req: true },
          { key: 'color', label: 'Exterior Color', val: this.selectedColor?.label || 'Not selected', price: this.prices.color, req: true },
          { key: 'jet', label: 'Nozzle Customization', val: this.config.jet, price: this.prices.jet, req: true }
        ];
        Object.entries(this.config.dynHw).forEach(([category, option]) => {
          list.push({ key: `hardware:${category}`, label: category, val: option.label,
            price: amount(option.price), req: true });
        });
        this.selectedFunctions.forEach(func => {
          list.push({ key: `function:${func.id}`, label: 'Function', val: func.label || func.id, price: func.price, req: false });
        });
        if (this.activeBundle) list.push({ key: 'bundle', label: 'Bundle', val: this.activeBundle.bundleId,
          price: this.activeBundle.bundlePrice, req: false });
        return list;
      },

      // These getters have no side effects; only the watcher starts an image load.
      get mainImageUrl() {
        if (!this.config.size || !this.selectedColor) return this.model?.img || '';
        const modelNum = this.config.sku.replace('Master', 'MPC');
        const color = this.config.color.replace(/ \+ /g, '_').replace(/ /g, '_');
        const faucetRaw = this.config.dynHw['Faucet color']?.id || 'Chrome';
        const faucet = faucetRaw === 'Glossy Black' ? 'Matte_Black' : faucetRaw.replace(/ /g, '_');
        const headrest = (this.config.dynHw['Headrest color']?.id || 'Black').replace(/ /g, '_');
        return `${CDN.primary}${encodeURIComponent(`${modelNum}_${color}_${faucet}_${headrest}`)}.webp`;
      },
      get mainImage() { return this.renderedImage || this.model?.img || ''; },
      loadMainImage(url) {
        this.previewImageUnavailable = false;
        const sequence = ++imageSequence;
        if (image) image.onload = image.onerror = null;
        if (!url) { this.renderedImage = ''; this.isImgLoading = false; return; }
        this.isImgLoading = true;
        image = new Image();
        const finish = (value, unavailable = false) => {
          if (destroyed || sequence !== imageSequence) return;
          this.previewImageUnavailable = unavailable;
          this.renderedImage = value;
          this.isImgLoading = false;
        };
        image.onload = () => finish(url);
        image.onerror = () => finish(this.model?.img || '', true);
        image.src = url;
      },

      selectModel(model) {
        const current = this.models.find(item => item.id === model?.id);
        if (!current || this.isSubmitting) return;
        model = current;
        this.model = model;
        this.config = { sku: model.id, size: '', color: '', jet: 'Soaking', dynHw: {}, functions: [] };
        this.syncColor(true);
        this.jetSelectionMessage = '';
        this.previewImageUnavailable = false;
        this.renderedImage = '';
        this.activeFuncTab = null;
        this.bundleSelected = false;
        this.frame360 = 0;
        this.sizeImgError = false;
        this.closeModals();
        this.syncHardware();
        this.step = 1;
        this.activeSection = 'size'; this.showDimensions = true; this.cartMessage = '';
        this.$nextTick(() => {
          this.$refs.optionsPanel?.scrollTo(0, 0);
          root.querySelector('[data-ec-config-scroll]')?.scrollTo(0, 0);
        });
      },
      selectSize(size) {
        const current = this.model?.sizes.find(item => item.id === size?.id);
        if (!current || this.isSubmitting || baseSizeUnavailable(current)) return;
        this.config.size = current.id;
        this.syncColor();
        this.jetSelectionMessage = '';
        if (this.config.jet !== 'Soaking' && this.isJetUnavailable(this.selectedJet)) {
          this.config.jet = 'Soaking';
          this.jetSelectionMessage = 'The previous Jets choice is not available for this size. Reset to Soaking (no jets); please review your massage options.';
        }
        this.sizeImgError = false;
        this.activeFuncTab = null;
        this.syncHardware();
        this.syncFunctions();
      },
      selectColor(color) {
        const current = this.colors.find(item => item.id === color?.id);
        if (!this.config.size || this.isSubmitting || !this.isColorAllowed(current)
            || this.isColorUnavailable(current)) return;
        this.config.color = current.id;
        this.activeFuncTab = null;
      },
      selectJet(id) {
        if (!this.config.size || this.isSubmitting) return;
        const choice = id === 'Soaking' ? null : parseJetChoice(id);
        const current = choice && this.rawJets.find(jet => jet.id === choice.id
          && jet.modelId === this.config.sku && jet.size === this.config.size);
        if (id !== 'Soaking' && this.isJetUnavailable(current)) {
          this.jetSelectionMessage = 'That Jets choice is not available for the current model and size. Please select a listed option.';
          return;
        }
        this.config.jet = current?.id || 'Soaking';
        this.jetSelectionMessage = '';
        this.activeFuncTab = null;
        this.syncHardware();
        this.syncFunctions();
      },
      setHardware(category, option) {
        const group = this.validHardwareCats.find(item => item.category === category);
        const valid = group?.options.find(item => item.id === option.id && !baseSizeUnavailable(item));
        if (valid) this.config.dynHw[category] = valid;
        this.activeFuncTab = null;
      },
      goBack() { this.closeModals(); this.step = 0; },
      closeModals() {
        this.show360 = this.showSummary = this.showFeedback = false;
        featureVideo?.close();
        dialogs?.closeAll();
      },
      hasFunctionVideo(func) { return isVideoId(func?.videoId); },
      openFunctionVideo(func, trigger) {
        const item = this.activeFunctions.find(candidate => candidate.id === func?.id);
        if (!item || !this.hasFunctionVideo(item)) return;
        // Previewing a video never selects an add-on or changes a price.
        dialogs?.closeAll({ restoreFocus: false });
        featureVideo?.open(item, trigger);
      },
      toggleFuncTab(func) { this.activeFuncTab = this.activeFuncTab === func.id ? null : func.id; },
      toggleFunction(func) {
        if (!this.config.size || !this.activeFunctions.some(item => item.id === func.id)) return;
        const index = this.config.functions.indexOf(func.id);
        if (index >= 0) {
          this.config.functions.splice(index, 1);
          if (func.id === THERMOSTAT) this.bundleSelected = false;
        } else this.config.functions.push(func.id);
      },
      toggleBundle() {
        const parent = this.activeFunctions.find(func => func.id === THERMOSTAT);
        if (!this.config.size || !parent?.hasBundle || parent.bundleAvailable === false) return;
        this.bundleSelected = !this.bundleSelected;
        // Selecting the thermostat's bundle also selects its parent thermostat.
        if (this.bundleSelected && !this.config.functions.includes(THERMOSTAT)) {
          this.config.functions.push(THERMOSTAT);
        }
      },
      cartSkuForHardware(category, value) {
        return category === 'Pillow position'
          ? `${this.config.sku}-${value}` : `${CART_SKU_PREFIX[category] || ''}${value}`;
      },
      buildCartItems(cartMetadata = {}) {
        if (!this.selectedSize) throw new Error('Please select a size first.');
        const base = this.connectedBaseSize();
        const color = this.connectedColor();
        const jet = this.connectedJet();
        const suffix = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        const binding = { Binding: `${this.config.sku}:${suffix}`, ...cartMetadata };
        const items = [];
        const missing = [];
        const add = (sku, price, required = false, directId = '') => {
          if (!directId && ambiguousSkus.has(sku)) throw new Error(`More than one variant uses SKU: ${sku}`);
          const id = String(directId || variantMap.get(sku) || '');
          if (!/^\d+$/.test(id)) {
            if (required || amount(price) > 0) missing.push(sku);
            return;
          }
          items.push({ id, properties: { ...binding }, quantity: 1 });
        };
        add(base.sku || `${this.config.sku}_${this.config.size}`, base.price, true, base.variantId);
        // Zero-price White is still its real color variant. A combo is ONE variant.
        add(color.sku, color.price, true, color.variantId);
        add(jet.sku, jet.price, true, jet.variantId);
        Object.entries(this.config.dynHw).forEach(([category, option]) => {
          add(this.cartSkuForHardware(category, option.id), option.price, false, option.variantId);
        });
        this.selectedFunctions.forEach(func =>
          add(func.sku || func.id, func.price, functionCatalog.enabled, func.variantId)
        );
        if (this.activeBundle) {
          add(this.activeBundle.bundleSku || this.activeBundle.bundleId, this.activeBundle.bundlePrice,
            functionCatalog.enabled, this.activeBundle.bundleVariantId);
        }
        if (missing.length) throw new Error(baseCatalog.enabled
          ? `Main/color/Jets links are valid, but these other add-on SKUs are not linked yet: ${missing.join(', ')}`
          : `Variant mapping failed. Please check Shopify SKUs: ${missing.join(', ')}`);
        // Included options do not always have standalone zero-price variants.
        // Preserve every choice on the base line even when those variants are absent.
        items[0].properties.Configuration = this.summaryDetails.map(item => `${item.label}: ${item.val}`).join(' | ');
        return items;
      },
      async addToCart() {
        return this.submitCartItems((cartMetadata) => {
          this.syncHardware();
          return this.buildCartItems(cartMetadata);
        }, 'Your configuration was added to cart.', Boolean(liquid.openCartAfterAdd), true);
      },
      async testBaseProductCart() {
        if (!this.baseLinkDesignMode) return;
        return this.submitCartItems(() => this.buildBaseOnlyTestItems(),
          'Connection test: one base bathtub was added to cart. No accessories were added.');
      },
      async submitCartItems(buildItems, successMessage, openCartDrawer = false, includeOrderMetadata = false) {
        if (this.isSubmitting || !this.selectedSize) return;
        this.isSubmitting = true;
        this.cartMessage = ''; this.cartIsError = false;
        clearTimeout(toastTimer);
        try {
          // Restore the legacy order metadata only for the real configuration add-to-cart.
          // Theme-editor connection tests stay clean and do not perform an external IP lookup.
          const cartMetadata = includeOrderMetadata ? await buildCartMetadata(liquid) : {};
          const items = buildItems(cartMetadata);
          const rootUrl = window.Shopify?.routes?.root || liquid.cartRoot || '/';
          const url = `${rootUrl.replace(/\/?$/, '/')}cart/add.js`;
          const response = await fetch(url, {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const payload = await response.json().catch(() => ({}));
          if (!response.ok || Number(payload.status) >= 400) {
            throw new Error(payload.description || payload.message || `Cart request failed (${response.status}).`);
          }
          // Release the native modal before the theme opens its cart drawer.
          if (!destroyed) {
            dialogs?.closeAll({ restoreFocus: false });
            this.showSummary = false;
            this.cartMessage = successMessage;
            this.cartIsError = false;
            toastTimer = setTimeout(() => { if (!destroyed) this.cartMessage = ''; }, 6000);
          }
          refreshThemeCart(openCartDrawer);
        } catch (error) {
          console.error('[EmpavaCustomApp]', error);
          if (!destroyed) {
            this.cartMessage = error.message || 'Unable to add items to cart.';
            this.cartIsError = true;
          }
        } finally {
          if (!destroyed) this.isSubmitting = false;
        }
      }
    };
  }

  function ensureAlpine() {
    if (alpinePromise) return alpinePromise;
    alpinePromise = new Promise((resolve, reject) => {
      let timer;
      let script;
      const cleanup = () => {
        clearTimeout(timer);
        document.removeEventListener('alpine:init', ready);
        if (script) script.removeEventListener('error', failed);
      };
      const failed = () => {
        cleanup();
        reject(new Error('Alpine could not load. Check the theme scripts, network or content security policy.'));
      };
      const ready = () => {
        const alpine = window.Alpine;
        if (!alpine || typeof alpine.data !== 'function' || typeof alpine.initTree !== 'function') return;
        cleanup();
        if (!registered.has(alpine)) {
          alpine.data(COMPONENT, createApp);
          registered.add(alpine);
        }
        resolve(alpine);
      };
      document.addEventListener('alpine:init', ready);
      timer = setTimeout(failed, 15000);
      if (window.Alpine) {
        if (!String(window.Alpine.version || '').startsWith('3.')) {
          cleanup();
          reject(new Error('This configurator requires Alpine 3. The existing theme Alpine was not replaced.'));
        } else ready();
        return;
      }
      // Reuse an Alpine script already scheduled by the theme; never load a second one.
      script = [...document.scripts].find(element => /(?:alpinejs|\/alpine(?:[.@/-]|\.min))/i.test(element.src));
      if (!script) {
        script = document.createElement('script');
        script.src = ALPINE_URL;
        script.async = true;
        script.dataset.empavaAlpine = 'true';
        script.addEventListener('error', failed, { once: true });
        document.head.appendChild(script);
      } else script.addEventListener('error', failed, { once: true });
    });
    return alpinePromise;
  }

  class EmpavaCustomBathtub extends HTMLElement {
    connectedCallback() {
      const boot = () => {
        if (!this.isConnected) return;
        ensureAlpine().then(alpine => {
          if (!this.isConnected || this.appRoot?.isConnected) return;
          const root = this.querySelector('[data-empava-app]');
          if (!root) throw new Error('The configurator markup is missing.');
          // Validate JSON before Alpine starts; failures remain visible in the loader.
          JSON.parse(this.querySelector('script[data-empava-config]')?.textContent || '');
          this.alpine = alpine;
          this.appRoot = root;
          alpine.mutateDom(() => {
            // Clean x-ignore if an earlier theme-wide Alpine scan already saw it.
            alpine.destroyTree(root);
            root.removeAttribute('x-ignore');
            root.setAttribute('x-data', `${COMPONENT}($el)`);
            alpine.initTree(root);
          });
          const status = this.querySelector('[data-empava-status]');
          if (status) status.hidden = true;
        }).catch(error => {
          console.error('[EmpavaCustomApp]', error);
          const status = this.querySelector('[data-empava-status]');
          if (status) { status.hidden = false; status.textContent = error.message; }
        });
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot, { once: true });
      } else queueMicrotask(boot);
    }

    disconnectedCallback() {
      // Native custom-element lifecycle also covers theme-editor section replacement.
      if (this.appRoot && this.alpine) {
        const root = this.appRoot;
        this.alpine.mutateDom(() => {
          this.alpine.destroyTree(root);
          root.removeAttribute('x-data');
          root.setAttribute('x-ignore', '');
          root.setAttribute('x-cloak', '');
        });
        this.appRoot = null;
      }
    }
  }
  // v1.8: Custom Studio cart trigger.
  // Does not depend on Impact header being visible.
  function openEmpavaCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return false;
    if (typeof drawer.show === 'function') { drawer.show(); return true; }
    if (typeof drawer.open === 'function') { drawer.open(); return true; }
    drawer.setAttribute('open', '');
    return true;
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('.ec-cart-open');
    if (!button) return;
    event.preventDefault();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
    setTimeout(openEmpavaCartDrawer, 100);
  });

  customElements.define(TAG, EmpavaCustomBathtub);
})();
